import { cloneDeep, now } from "lodash";
import { supabase } from "../supabaseClient";
import axios from "axios";
import store from "../Redux Store/store";

async function getAllotments(name, allotmentPaymentId, roleId) {
  let query = supabase
    .from("AllotmentPayment")
    .select(
      `*, leadId(*, personId(*), userId(*), cpId(*), fosId(*)), unitId(*, inventoryTypeId(*), projectId(*), wingId(*))`,
      {
        count: "exact",
      },
    );

  if (name) {
    query = query.ilike("name", "%" + name + "%");
  }

  if (roleId && roleId != "all") {
    query = query.eq("roleId", roleId);
  }

  if (allotmentPaymentId) {
    query = query.eq("allotmentPaymentId", allotmentPaymentId).maybeSingle();

    let transactionQuery = supabase
      .from("AllotmentTransactions")
      .select("*", { count: "exact" });

    const { data, error, count } = await transactionQuery;
    if (data) {
      var transactionData = data;
    } else throw error;
  }
  const { data, error, count } = await query;
  if (data) return { data, count, transactionData };
  else throw error;
}

async function getFilterNames(filterTable) {
  const { data, error, count } = await supabase
    .from(filterTable)
    .select("*", { count: "exact" });
  if (data) return { data };
  else throw error;
}

async function getFilterNamesCollaterals(filterTable, id) {
  if (filterTable === "SustenanceCpRelations") {
    const { data, error, count } = await supabase
      .from(filterTable)
      .select("*,CP!left(*)", { count: "exact" })
      .eq("projectId", id);
    if (data) return { data };
    else throw error;
  } else {
    const { data, error, count } = await supabase
      .from(filterTable)
      .select("*,Users!left(*)", { count: "exact" })
      .eq("projectId", id);
    if (data) return { data };
    else throw error;
  }
}

async function insertAllotmentTransactions(obj) {
  let newobj = cloneDeep(obj);
  delete newobj.paymentDetails.chequeImg;
  const { data, error, count } = await supabase
    .from("AllotmentTransactions")
    .insert(newobj);
  if (data) return { data };
  else throw error;
}

async function insertIntoAllotmentTransactions(obj) {
  const { data, error, count } = await supabase
    .from("AllotmentTransactions")
    .insert(obj);
  if (data) return { data };
  else throw error;
}

async function deleteOldParkingRecords(parkingInventoryId) {
  return await supabase
    .from("ParkingSelection")
    .delete()
    .eq("parkingInventoryId", parkingInventoryId)
    .select("*");
}

async function insertParkingDetails(obj) {
  // const { data, error } = await supabase.from("ParkingSelection").upsert(obj, {onConflict : "allotmentPaymentId"});
  const { data, error } = await supabase.from("ParkingSelection").insert(obj);
  if (data) return { data };
  else throw error;
}

async function updateParkingStatusFlag(parkingInventoryId, flag) {
  const { data, error } = await supabase
    .from("ParkingInventory")
    .update({ parkingStatusId: flag })
    .eq("parkingInventoryId", parkingInventoryId)
    .select("*")
    .maybeSingle();
  if (data) return { data };
  else throw error;
}

// CRM2 M1.16: every CRM log saves who did it (CRMLogs.userId = the logged-in
// user), in this one place for all callers. A row that already names a user keeps it.
async function insertCRMLogs(obj) {
  const userId = store.getState()?.Auth?.user?.userId || null;
  if (!userId) console.warn("[crm2][insertCRMLogs] no logged-in user; log saved without a user");
  const withUser = (row) => (row && !row.userId && userId ? { ...row, userId } : row);
  const rows = Array.isArray(obj) ? obj.map(withUser) : withUser(obj);
  const { data, error } = await supabase.from("CRMLogs").insert(rows);
  if (data) return { data };
  else throw error;
}

// Reads the parking-upgrade cost and the request-raiser's remark straight from
// the CRM row. The CRM list endpoints are RPCs with a fixed column set (they
// return neither), so the modal fetches them directly by CRM id.
async function getParkingUpgradeCost(crmId) {
  const { data, error } = await supabase
    .from("CRM")
    .select("parkingUpgradeCost, remarks")
    .eq("id", crmId)
    .maybeSingle();
  if (error) throw error;
  return { data };
}

async function fetchParkingData(id) {
  const { data, error } = await supabase
    .from("ParkingSelection")
    .select("*")
    .eq("allotmentPaymentId", id);
  if (data) return { data };
  else throw error;
}

function dataURLtoFile(dataurl, filename) {
  var arr = dataurl.split(","),
    mime = arr[0].match(/:(.*?);/)[1],
    bstr = atob(arr[1]),
    n = bstr.length,
    u8arr = new Uint8Array(n);

  while (n--) {
    u8arr[n] = bstr.charCodeAt(n);
  }

  return new File([u8arr], filename, { type: mime });
}

async function uploadChequeImage(obj, id) {
  const file = dataURLtoFile(obj, `${id}.webp`);
  const { data, error } = await supabase.storage
    .from("cheques")
    .upload(`${id}.webp`, file);
  if (data) return { data };
  else throw error;
}

async function getFilterById(filters) {
  let all_cpId = [];
  let all_salesRepresentativeId = [];
  let all_projectId = [];

  let jsonParse;
  filters.map((item) => {
    jsonParse = JSON.parse(item);
    if (jsonParse.filter == "CP") {
      all_cpId.push(jsonParse.value);
    } else if (jsonParse.filter == "Projects") {
      all_salesRepresentativeId.push(jsonParse.value);
    } else if (jsonParse.filter == "Users") {
      all_projectId.push(jsonParse.value);
    }
  });

  // const { data, error } = await supabase.from("AllotmentPayment").select('*', { count: 'exact' });
  // if (data) return { data };
  // else throw error;
}

async function updateAllotmentPayment(obj, allotmentPaymentId) {
  // obj.last_updated_at = new Date().getTime();
  const { data, error, count } = await supabase
    .from("AllotmentPayment")
    .update(obj)
    .eq("allotmentPaymentId", allotmentPaymentId)
    .select("*,CRM!left(*)");
  if (data) return { data };
  else throw error;
}
async function getAllotmentsFilter(
  checked,
  allotmentId,
  search,
  drpDownSelectedVal,
  from,
  to,
) {
  if (search === undefined) {
    search = null;
  }

  const filters = {
    "Name Ascending": {
      key: "leadname",
      isAscending: true,
    },
    "Name Descending": {
      key: "leadname",
      isAscending: false,
    },
    "Oldest First": {
      key: "lastupdated",
      isAscending: true,
    },
    "Latest First": {
      key: "lastupdated",
      isAscending: false,
    },
  };
  var query;
  // query =  supabase
  //   .from('CpContactPerson')
  //   .select('*, cpId(*,KycDocuments!left(*),recommendedBySalesId(*))', { count: 'exact' })
  //   .order(filters[drpDownSelectedVal].key, { ascending: filters[drpDownSelectedVal].isAscending })
  //   .range(from, to);

  query = supabase
    .rpc("allotmentfilter", {}, { count: "exact" })
    .order(filters[drpDownSelectedVal].key, {
      ascending: filters[drpDownSelectedVal].isAscending,
    });

  let all_cpId = [];
  let all_projectId = [];
  let all_salesRepresentativeId = [];
  let jsonParse;

  if (allotmentId) {
    query = query.eq("allotmentpaymentid", allotmentId);

    let transactionQuery = supabase
      .from("AllotmentTransactions")
      .select("*", { count: "exact" })
      .eq("allotmentPaymentId", allotmentId);
    // let transactionQuery = query

    const { data, error, count } = await transactionQuery;
    if (data) {
      var transactionData = data;
    } else throw error;
  }

  if (checked) {
    checked.map((item) => {
      jsonParse = JSON.parse(item);
      if (jsonParse.filter == "CP") {
        all_cpId.push(jsonParse.value);
      } else if (jsonParse.filter == "Projects") {
        all_projectId.push(jsonParse.value);
      } else if (jsonParse.filter == "Users") {
        all_salesRepresentativeId.push(jsonParse.value);
      }
    });
  }

  // return

  if (all_cpId.length !== 0) {
    query = query.in("cpid", all_cpId);
  }

  if (all_salesRepresentativeId.length !== 0) {
    query = query.in("userid", all_salesRepresentativeId);
  }

  if (all_projectId.length !== 0) {
    query = query.in("projectid", all_projectId);
  }

  if (search) {
    // search = search.replace(/\s\s+/g, ' ')
    query = query.or(`leadname.ilike.%${search}%,unitno.ilike.%${search}%`);
  }
  if (from) {
    query = query.gt("totalcost", from);
  }

  if (to) {
    query = query.lt("totalcost", to);
  }
  //Main query
  // const { data, error, count } = await supabase
  //   .from('CpContactPerson')
  //   .select('*, cpId(*,KycDocuments!left(*),recommendedBySalesId(*))', { count: 'exact' })
  //   .ilike('name', `%${search}%`)

  const { data, count, error } = await query;
  if (data) return { data, count, transactionData };
  else throw error;
}

async function getAllotmentPayment(
  search,
  filterBy,
  page,
  checked,
  type,
  projectStr,
  nextRange,
  selectedDate,
  isTable,
) {
  const { p, w, f } = projectStr;
  let all_cpId = [];
  let all_projectId = [];
  let all_salesRepresentativeId = [];
  let all_status = [];
  let all_crmUsersId = [];
  let all_kyc = [];
  let all_crm_taged = [];
  let leadType = [];
  let jsonParse;
  const limit = 10;
  const fromCount = isTable ? nextRange?.from : page * limit;
  const toCount = isTable ? nextRange?.to : page * limit + (limit - 1);
  // let query = supabase.rpc('allotmentfilter').order(filterBy.includes('Name') ? 'leadname' : 'lastupdated', { ascending: (filterBy.includes('Oldest') || filterBy.includes('Ascending')) ? true : false }).range(page === 0 ? page * 10 : page * 10 + 1, page === 0 ? ((page + 1) * 10) : (page * 10 + 10))
  let query = supabase
    .rpc("allotmentfilter", {}, { count: "exact" })
    .order(
      filterBy.includes("Name")
        ? "leadname"
        : filterBy.includes("Unit")
          ? "unitno"
          : "lastupdated",
      {
        ascending:
          filterBy.includes("Oldest") || filterBy.includes("Ascending")
            ? true
            : false,
      },
    )
    .range(fromCount, toCount);
  if (type?.value === "Pending") {
    query = query
      .or("status.eq.Payment Pending,status.eq.Partial Payment Done")
      .neq("pricingtype", "preselect");
  }
  if (type?.value === "On Hold") {
    query = query.eq("status", "On Hold").neq("pricingtype", "preselect");
  }
  if (type?.value === "Completed") {
    // query = query.eq('status', 'Payment Complete').eq('kycformfilled', true).neq('pricingtype', 'preselect')
    query = query.eq("status", "Payment Complete").eq("kycformfilled", true);
  }
  if (type?.value === "Parking Selection") {
    query = query.eq("status", "Payment Complete").eq("kycformfilled", true);
  }

  if (type?.value === "Preselect") {
    query = query.eq("pricingtype", "preselect");
  }
  if (type?.value === "All") {
    // query = query.neq('pricingtype', 'preselect')
    query = query;
  }
  if (search && search !== "") {
    query = query.or(`leadname.ilike.%${search}%,unitno.ilike.%${search}%`);
  }
  if (checked && checked.length > 0) {
    checked.map((item) => {
      jsonParse = JSON.parse(item);
      if (jsonParse.filter == "CP") {
        all_cpId.push(jsonParse.value);
      } else if (jsonParse.filter == "Projects") {
        all_projectId.push(jsonParse.value);
      } else if (jsonParse.filter == "Users") {
        all_salesRepresentativeId.push(jsonParse.value);
      } else if (jsonParse.filter == "CrmUsers") {
        all_crmUsersId.push(jsonParse.value);
      } else if (jsonParse.filter == "Status") {
        all_status.push(jsonParse.value);
      } else if (jsonParse.filter == "Kyc") {
        all_kyc.push(jsonParse.value);
      } else if (jsonParse.filter == "CRM Tagged") {
        all_crm_taged.push(jsonParse.value);
      } else if (jsonParse.filter == "Lead Type") {
        leadType.push(jsonParse.value);
      }
    });
  }

  // return

  if (all_cpId.length !== 0) {
    query = query.in("cpid", all_cpId);
  }

  if (
    selectedDate?.[0]?.value !== "" &&
    selectedDate?.[1]?.value !== "" &&
    selectedDate !== undefined
  ) {
    query = query
      .lte("allotmentdate", Date.parse(new Date(selectedDate?.[1]?.value)))
      .gte("allotmentdate", Date.parse(new Date(selectedDate?.[0]?.value)));
  }

  if (all_salesRepresentativeId.length !== 0) {
    query = query.in("userid", all_salesRepresentativeId);
  }

  if (all_kyc.length !== 0) {
    if (all_kyc?.includes("Kyc Pending")) {
      const index = all_kyc.findIndex((v) => v === "Kyc Pending");
      all_kyc?.splice(index, 1);
      all_kyc?.push(false);
    }

    if (all_kyc?.includes("Kyc Done")) {
      const index = all_kyc.findIndex((v) => v === "Kyc Done");
      all_kyc?.splice(index, 1);
      all_kyc?.push(true);
    }
    query = query.in("kycformfilled", all_kyc);
  }

  if (all_crm_taged.length !== 0) {
    if (all_crm_taged?.includes("CRM Tagged")) {
      query = query.not("crmuserid", "is", null);
    }

    if (all_crm_taged?.includes("CRM Not Tagged")) {
      query = query.is("crmuserid", null);
    }
  } else {
    if (type?.value === "Completed") {
      query = query.is("crmuserid", null);
    }
  }

  if (all_crm_taged.length !== 0) {
    if (all_crm_taged?.includes("CRM Tagged")) {
      query = query.not("crmuserid", "is", null);
    }

    if (all_crm_taged?.includes("CRM Not Tagged")) {
      query = query.is("crmuserid", null);
    }
  } else {
    if (type?.value === "Parking Selection") {
      query = query.is("crmuserid", null);
    }
  }

  if (leadType.length !== 0) {
    if (leadType?.includes("Direct")) {
      const index = leadType.findIndex((v) => v === "Direct");
      leadType?.splice(index, 1);
      leadType?.push("Direct");
    }

    if (leadType?.includes("CP")) {
      const index = leadType.findIndex((v) => v === "CP");
      leadType?.splice(index, 1);
      leadType?.push("CP");
    }
    if (leadType?.includes("R&L")) {
      const index = leadType.findIndex((v) => v === "R&L");
      leadType?.splice(index, 1);
      leadType?.push("R&L");
    }
    query = query.in("leadtype", leadType);
  }
  if (all_projectId.length !== 0) {
    if (all_projectId[0]?.[0]?.["p"]?.length > 0) {
      query = query.in("projectid", all_projectId[0]?.[0]?.["p"]);
    }

    if (all_projectId[0]?.[0]?.["w"]?.length > 0) {
      query = query.in("wingid", all_projectId[0]?.[0]?.["w"]);
    }

    if (all_projectId[0]?.[0]?.["f"]?.length > 0) {
      // const payload = all_projectId[0]?.[0]?.["f"]?.map((val) => {
      //   const string = val.replace("FLOOR ", "");
      //   return string;
      // });
      query = query.in("floorno", all_projectId[0]?.[0]?.["f"]);
    }
  }

  if (all_crmUsersId.length !== 0) {
    query = query.in("crmuserid", all_crmUsersId);
  }

  if (all_status.length !== 0) {
    let str = [];
    if (all_status.includes("Pending")) {
      // query = query.eq('paidamount', 0);
      str.push(`paidamount.eq.0`);
    }
    if (all_status.includes("Partial")) {
      // query = query.gt('paidamount', 0).lt('paidamount', 500000);
      // str = str + `paidamount.lt.500000,paidamount.gt.0`
      str.push(`and(paidamount.lt.500000,paidamount.gt.0)`);
    }
    if (all_status.includes("Complete")) {
      // query = query.eq('paidamount', 500000);
      str.push(`paidamount.eq.500000`);
      // str = str + `paidamount.eq.500000`
    }
    if (str.length) query = query.or(str.join(","));

    query = query.in("status", all_status);
  }

  // if (mode === 'preselect') {
  //   query = query.eq('pricingtype', 'preselect');
  // } else {
  //   query = query.neq('pricingtype', 'preselect');
  // }
  if (
    JSON.parse(localStorage.getItem("user")).roleId.accessibleTabs[
      "All Allotments"
    ]["Show Allotments"]?.show !== "All"
  ) {
    // query = query.eq('userid', JSON.parse(localStorage.getItem('user')).userId)
    // !!sarita changes
    query = query.in("userid", JSON.parse(localStorage.getItem("teamIds")));
  }

  // const { data, error, count } = await query;
  // if (data) return { data, count };
  // else throw error;

  const { data, error, count } = await query;

  if (error) throw error;

  // 🧠 Apply allowParkingSelection filter only for Parking Selection tab
  if (type?.value === "Parking Selection" && data?.length) {
    // 1️⃣ Get project IDs where allowParkingSelection = true
    const { data: allowedProjects, error: projectError } = await supabase
      .from("Projects")
      .select("projectId")
      .eq("allowParkingSelection", true)
      .eq("isVJ", true);

    if (projectError) throw projectError;

    const allowedProjectIds = allowedProjects?.map((p) => p.projectId) || [];

    // 2️⃣ Get inventory items that belong to those allowed projects
    const { data: allowedInventory, error: inventoryError } = await supabase
      .from("Inventory")
      .select("unitId, projectId")
      .in("projectId", allowedProjectIds);

    if (inventoryError) throw inventoryError;

    const allowedUnitIds = allowedInventory?.map((inv) => inv.unitId) || [];

    // 3️⃣ Filter allotments that belong to the allowed units
    const filteredData = data.filter((item) =>
      allowedUnitIds.includes(item.unitid),
    );

    // ✅ Return only filtered data for Parking Selection tab
    return { data: filteredData, count: filteredData.length };
  }

  return { data, count };
}

async function getAllotmentById(id) {
  const { data, error } = await supabase
    .from("AllotmentPayment")
    .select(
      "*,unitId(*,inventoryTypeId(*),projectId(*),wingId(*)),inventoryMergedId(*,unit1Id(*,inventoryTypeId(*),projectId(*)),unit2Id(*,inventoryTypeId(*),projectId(*))),leadId(*,personId(*)),paymentId(*,eventId(*))",
    )
    .eq("allotmentPaymentId", id);
  if (data) return { data };
  else throw error;
}

async function getURLFromAgreementForm(id) {
  const { data, error } = await supabase
    .from("AgreementForm")
    .select("agreementSuccess")
    .eq("allotmentPaymentId", id);

  if (data) return { data };
  else throw error;
}

// async function getStampDetailsBookingUrl(id){
// 	const { data, error } = await supabase
// 		.from("StampDetails")
// 		.select("bookUrl")
// 		.eq("bookingId", id)

// 	if (data) return { data };
// 	else throw error;
// }

async function getAllotmentTransactions(id) {
  const { data, error } = await supabase
    .from("AllotmentTransactions")
    .select("*,machineId(*)")
    .eq("allotmentPaymentId", id)
    .eq("status", "pending")
    .eq("modeOfPayment", "POS Machine");
  if (data) return { data };
  else throw error;
}

async function getAllAllotmentTransactions(id) {
  const { data, error } = await supabase
    .from("AllotmentTransactions")
    .select("*")
    .eq("allotmentPaymentId", id)
    .order("last_updated_at", { ascending: false });
  if (data) return { data };
  else throw error;
}

async function getApiSuccessLogs(allotmentPaymentId) {
  const { data, error } = await supabase
    .from("FarvisionApiSuccessLogs")
    .select("id, type, created_at, payload")
    .eq("allotmentPaymentId", allotmentPaymentId);
  if (data) return { data };
  else throw error;
}

async function getErrorResponseForApiType(allotmentPaymentId) {
  const { data, error } = await supabase
    .from("FarvisionApiErrorLogs")
    .select("*")
    .eq("allotmentPaymentId", allotmentPaymentId);
  if (data) return { data };
  else throw error;
}

async function changeUpdateSDRStatus(allotmentPaymentId) {
  const { data, error } = await supabase
    .from("AllotmentPayment")
    .update({ isBucketingApplied: true })
    .eq("allotmentPaymentId", allotmentPaymentId)
    .select("*")
    .maybeSingle();
  if (data) return { data };
  else throw error;
}

async function approveUpdateSDRStatus(crmAllotmentId) {
  const { data, error } = await supabase
    .from("CRM")
    .update({
      crmStatusId: process.env.REACT_APP_PARKING_SELECTION,
      last_updated_at: Date.now(),
    })
    .eq("id", crmAllotmentId)
    .select("*")
    .maybeSingle();
  if (data) return { data };
  else throw error;
}

async function updateUnitCostInAllotmentPayment(payload, allotmentPaymentId) {
  const { data, error } = await supabase
    .from("AllotmentPayment")
    .update({ unitCost: payload })
    .eq("allotmentPaymentId", allotmentPaymentId)
    .select("*");
  if (data) return { data };
  else throw error;
}

async function ChangeBookingAmountValues(
  updatedbookingAmount,
  allotmentStatus,
  allotmentPaymentId,
) {
  return await supabase
    .from("AllotmentPayment")
    .update({ bookingAmt: updatedbookingAmount, status: allotmentStatus })
    .eq("allotmentPaymentId", allotmentPaymentId)
    .select("*")
    .maybeSingle();
}

async function insertUpdatedBookingAmountLogs(obj) {
  const { data, error } = await supabase.from("BookingAmountLogs").insert(obj);
  if (data) return { data };
  else throw error;
}

async function insertInventoryLogs(obj) {
  const { data, error, count } = await supabase
    .from("InventoryLogs")
    .insert(obj);
  if (data) return { data };
  else throw error;
}

async function getAllMachines() {
  const { data, error } = await supabase.from("POSMachines").select("*");
  if (data) return { data };
  else throw error;
}

async function getCrmAllotments(requestPendingCrmUserId, pageNumber) {
  const limit = 10;
  const fromCount = pageNumber * limit;
  const toCount = pageNumber * limit + (limit - 1);
  return await supabase
    .from("CRM")
    .select(
      "*, crmUserId(*), requestPendingWith(*), allotmentPaymentId(*, userId(*),paymentId(*, eventId(*)),leadId(*, personId(*)), unitId(*, wingId(*), projectId(*), inventoryTypeId(*)), inventoryMergedId(*, unit1Id(*, wingId(*), projectId(*)), unit2Id(*)))",
      { count: "exact" },
    )
    .eq("requestPendingWith", requestPendingCrmUserId)
    .range(fromCount, toCount);
}

async function getTagPendingCrmAllotments(
  requestPendingCrmUserId,
  pageNumber,
  search_lead_name,
  filterBy,
  checked = [],
  selectedDate,
  nextRange,
  isTableView,
) {
  let all_cpId = [];
  let all_projectId = [];
  let all_salesRepresentativeId = [];
  let all_status = [];
  let all_crmUsersId = [];
  let all_email = [];
  let all_sdr = [];
  let lead_Type = [];
  let jsonParse;

  const limit = 10;
  const fromCount = isTableView ? nextRange?.from : pageNumber * limit;
  const toCount = isTableView
    ? nextRange?.to
    : pageNumber * limit + (limit - 1);

  // let query = supabase.from("CRM").select("*, crmUserId(*), requestPendingWith(*), allotmentPaymentId(*, userId(*),paymentId(*, eventId(*)),leadId(*, personId(*)), unitId(*, wingId(*), projectId(*), inventoryTypeId(*)), inventoryMergedId(*, unit1Id(*, wingId(*), projectId(*)), unit2Id(*)))", { count: "exact" });
  let query = supabase
    .rpc(
      "get_tag_pending_crm_allotments",
      { search_lead_name: search_lead_name },
      { count: "exact" },
    )
    .order(
      filterBy.includes("Name")
        ? "lead_name"
        : filterBy.includes("Unit")
          ? "unit_no"
          : "last_updated_at",
      {
        ascending:
          filterBy.includes("Oldest") || filterBy.includes("Ascending")
            ? true
            : false,
      },
    );

  // if (requestPendingCrmUserId && requestPendingCrmUserId !== "") {
  //   query = query.eq("requestPendingWith", requestPendingCrmUserId);
  // }

  if (checked && checked.length > 0) {
    checked.map((item) => {
      jsonParse = JSON.parse(item);
      if (jsonParse.filter == "CP") {
        all_cpId.push(jsonParse.value);
      } else if (jsonParse.filter == "Projects") {
        all_projectId.push(jsonParse.value);
      } else if (jsonParse.filter == "Users") {
        all_salesRepresentativeId.push(jsonParse.value);
      } else if (jsonParse.filter == "CrmUsers") {
        all_crmUsersId.push(jsonParse.value);
      } else if (jsonParse.filter == "Status") {
        all_status.push(jsonParse.value);
      } else if (jsonParse.filter == "Email") {
        all_email.push(jsonParse.value);
      } else if (jsonParse.filter === "SDR") {
        all_sdr.push(jsonParse.value);
      } else if (jsonParse.filter === "Lead Type") {
        lead_Type.push(jsonParse.value);
      }
    });
  }

  // return

  if (
    selectedDate?.[0]?.value !== "" &&
    selectedDate?.[1]?.value !== "" &&
    selectedDate !== undefined
  ) {
    query = query
      .lte("created_at", Date.parse(new Date(selectedDate?.[1]?.value)))
      .gte("created_at", Date.parse(new Date(selectedDate?.[0]?.value)));
  }

  if (all_email.length !== 0) {
    if (all_email?.includes("Email Sent")) {
      const index = all_email.findIndex((v) => v === "Email Sent");
      all_email?.splice(index, 1);
      all_email?.push(true);
    }

    if (all_email?.includes("Email Not Sent")) {
      const index = all_email.findIndex((v) => v === "Email Not Sent");
      all_email?.splice(index, 1);
      all_email?.push(false);
    }
    query = query.in("isemailsent", all_email);
  }

  if (all_cpId.length !== 0) {
    query = query.ilike("cpname", all_cpId);
  }

  if (all_salesRepresentativeId.length !== 0) {
    query = query.ilike("sales_user_name", all_salesRepresentativeId);
  }

  if (all_crmUsersId.length !== 0) {
    query = query.ilike("crm_user_name", all_crmUsersId);
  }

  if (all_sdr?.length !== 0) {
    if (all_sdr.includes("SDR Pending")) {
      const index = all_sdr.findIndex((v) => v === "SDR Pending");
      all_sdr?.splice(index, 1);
      all_sdr?.push(false);
    }

    if (all_sdr?.includes("SDR Complete")) {
      const index = all_sdr.findIndex((v) => v === "SDR Complete");
      all_sdr?.splice(index, 1);
      all_sdr?.push(true);
    }

    query = query.in("sdrcomplete", all_sdr);
  }

  if (all_projectId.length !== 0) {
    if (all_projectId[0]?.[0]?.["p"]?.length > 0) {
      query = query.in("project_id", all_projectId[0]?.[0]?.["p"]);
    }

    if (all_projectId[0]?.[0]?.["w"]?.length > 0) {
      query = query.in("wing_id", all_projectId[0]?.[0]?.["w"]);
    }

    if (all_projectId[0]?.[0]?.["f"]?.length > 0) {
      // const payload = all_projectId[0]?.[0]?.["f"]?.map((val) => {
      //   const string = val.replace("FLOOR ", "");
      //   return string;
      // });
      query = query.in("floor_no", all_projectId[0]?.[0]?.["f"]);
    }
  }

  if (all_status.length !== 0) {
    query = query.ilike("status", all_status);
  }

  if (lead_Type?.length !== 0) {
    console.log("lead_Type", lead_Type);
    if (lead_Type.includes("Direct")) {
      query = query.eq("leadtype", "Direct");
    }
    if (lead_Type.includes("CP")) {
      query = query.eq("leadtype", "CP");
    }
    if (lead_Type.includes("R&L")) {
      query = query.eq("leadtype", "R&L");
    }
  }
  if (requestPendingCrmUserId && requestPendingCrmUserId !== "") {
    query = query.eq("request_pending_with", requestPendingCrmUserId);
  }
  query = query.range(fromCount, toCount);
  return await query;
}

async function getSentEmailCount(tabId, requestPendingCrmUserId) {
  var query;
  query = supabase
    .from("CRM")
    .select("*", { count: "exact" })
    .eq("crmStatusId", tabId)
    .eq("isEmailSent", true);

  if (requestPendingCrmUserId && requestPendingCrmUserId !== "") {
    query = query.eq("requestPendingWith", requestPendingCrmUserId);
  }

  const { data, count, error } = await query;
  if (data) return { count };
}

// unitId is optional: when the unit is a JD/landowner unit, its SDR %, legal and
// registration charges come from its JD project instead of the VJ parent project.
async function getSdrPercentageAndLegalCharges(projectId, unitId) {
  const jdProjectId = unitId ? await getJdProjectIdForUnit(projectId, unitId) : null;

  var query;
  query = supabase
    .from("Projects")
    .select("sdrPercentage, legalCharges, registrationCharges")
    .eq("projectId", jdProjectId || projectId);

  const { data, error } = await query;
  if (data) return { data };
  else throw error;
}

// JD units sit under the VJ parent project; their JD project is the isVJ=false
// project of the same parent whose buId is the unit's Inventory.jdBuId.
// Returns null for VJ units (or when no JD project is linked yet).
async function getJdProjectIdForUnit(parentProjectId, unitId) {
  const jdBuId = await getJdBuIdForUnit(unitId);
  if (!jdBuId) return null;

  const { data, error } = await supabase
    .from("Projects")
    .select("projectId")
    .eq("buId", jdBuId)
    .eq("isVJ", false)
    .eq("salesParentProjectId", parentProjectId)
    .maybeSingle();

  if (error) throw error;
  return data?.projectId || null;
}

// Company + RERA printed on documents of a JD unit (its JD project's Projects.companyName /
// reraNumber). Returns null for VJ units, so callers keep their existing VJ text.
async function getJdCompanyDetailsForUnit(parentProjectId, unitId) {
  const jdProjectId = await getJdProjectIdForUnit(parentProjectId, unitId);
  if (!jdProjectId) return null;

  const { data, error } = await supabase
    .from("Projects")
    .select("companyName, reraNumber")
    .eq("projectId", jdProjectId)
    .maybeSingle();

  if (error) throw error;
  return data?.companyName ? data : null;
}

// Batch version for list RPC rows: unitId -> { projectId, wingId } of the JD project/wing
// whose Additional Configuration applies. Only JD units (Inventory.jdBuId set) are returned.
// inventoryRows must carry unitId, jdBuId, jdWingId; rows need unit_id and project_id.
async function getJdConfigTargetsForUnits(inventoryRows, rows) {
  const jdRows = (inventoryRows || []).filter((inv) => inv.jdBuId && inv.jdWingId);
  if (jdRows.length === 0) return {};

  const parentByUnit = {};
  (rows || []).forEach((a) => { parentByUnit[a.unit_id] = a.project_id; });

  const { data: jdProjects } = await supabase
    .from("Projects")
    .select("projectId, buId, salesParentProjectId")
    .eq("isVJ", false)
    .in("buId", [...new Set(jdRows.map((inv) => inv.jdBuId))]);

  const targets = {};
  jdRows.forEach((inv) => {
    const jdProject = jdProjects?.find(
      (p) => String(p.buId) === String(inv.jdBuId) && p.salesParentProjectId === parentByUnit[inv.unitId]
    );
    if (jdProject) targets[inv.unitId] = { projectId: jdProject.projectId, wingId: inv.jdWingId };
  });
  return targets;
}

// JD units sit under the VJ parent project; Inventory.jdBuId marks them and holds
// the JD buId used by the JD Farvision API. Returns null for VJ units.
async function getJdBuIdForUnit(unitId) {
  const { data, error } = await supabase
    .from("Inventory")
    .select("jdBuId")
    .eq("unitId", unitId)
    .maybeSingle();

  if (error) throw error;
  return data?.jdBuId ?? null;
}

async function getTagApprovedCrmAllotments(
  requestPendingCrmUserId,
  pageNumber,
  search_lead_name,
  filterBy,
  checked = [],
  selectedDate,
  nextRange,
  isTableView,
  emailCount,
) {
  let all_cpId = [];
  let all_projectId = [];
  let all_salesRepresentativeId = [];
  let all_status = [];
  let all_crmUsersId = [];
  let all_email = [];
  let all_sdr = [];
  let all_ocr = [];
  let all_av = [];
  let all_agreement_kyc = [];
  let lead_Type = [];
  let jsonParse;

  const limit = 10;
  const fromCount = isTableView ? nextRange?.from : pageNumber * limit;
  const toCount = isTableView
    ? nextRange?.to
    : pageNumber * limit + (limit - 1);

  // let query = supabase.from("CRM").select("*, crmUserId(*), requestPendingWith(*), allotmentPaymentId(*, userId(*),paymentId(*, eventId(*)),leadId(*, personId(*)), unitId(*, wingId(*), projectId(*), inventoryTypeId(*)), inventoryMergedId(*, unit1Id(*, wingId(*), projectId(*)), unit2Id(*)))", { count: "exact" });
  let query = supabase
    .rpc(
      "get_tag_approved_crm_allotments",
      { search_lead_name: search_lead_name },
      { count: "exact" },
    )
    .order(
      filterBy.includes("Name")
        ? "lead_name"
        : filterBy.includes("Unit")
          ? "unit_no"
          : "last_updated_at",
      {
        ascending:
          filterBy.includes("Oldest") || filterBy.includes("Ascending")
            ? true
            : false,
      },
    );

  // if (requestPendingCrmUserId && requestPendingCrmUserId !== "") {
  //   query = query.eq("requestPendingWith", requestPendingCrmUserId);
  // }

  if (checked && checked.length > 0) {
    checked.map((item) => {
      jsonParse = JSON.parse(item);
      if (jsonParse.filter == "CP") {
        all_cpId.push(jsonParse.value);
      } else if (jsonParse.filter == "Projects") {
        all_projectId.push(jsonParse.value);
      } else if (jsonParse.filter == "Users") {
        all_salesRepresentativeId.push(jsonParse.value);
      } else if (jsonParse.filter == "CrmUsers") {
        all_crmUsersId.push(jsonParse.value);
      } else if (jsonParse.filter == "Status") {
        all_status.push(jsonParse.value);
      } else if (jsonParse.filter == "Email") {
        all_email.push(jsonParse.value);
      } else if (jsonParse.filter === "SDR") {
        all_sdr.push(jsonParse.value);
      } else if (jsonParse.filter === "OCR") {
        all_ocr.push(jsonParse.value);
      } else if (jsonParse.filter === "AV") {
        all_av.push(jsonParse.value);
      } else if (jsonParse.filter === "Agreement KYC") {
        all_agreement_kyc.push(jsonParse.value);
      } else if (jsonParse.filter === "Lead Type") {
        lead_Type.push(jsonParse.value);
      }
    });
  }

  // return

  if (
    selectedDate?.[0]?.value !== "" &&
    selectedDate?.[1]?.value !== "" &&
    selectedDate !== undefined
  ) {
    query = query
      .lte("created_at", Date.parse(new Date(selectedDate?.[1]?.value)))
      .gte("created_at", Date.parse(new Date(selectedDate?.[0]?.value)));
  }

  if (all_email.length !== 0) {
    if (all_email?.includes("Email Sent")) {
      const index = all_email.findIndex((v) => v === "Email Sent");
      all_email?.splice(index, 1);
      all_email?.push(true);
    }

    if (all_email?.includes("Email Not Sent")) {
      const index = all_email.findIndex((v) => v === "Email Not Sent");
      all_email?.splice(index, 1);
      all_email?.push(false);
    }
    query = query.in("isemailsent", all_email);
  }

  if (all_cpId.length !== 0) {
    query = query.ilike("cpname", all_cpId);
  }

  if (all_salesRepresentativeId.length !== 0) {
    query = query.ilike("sales_user_name", all_salesRepresentativeId);
  }

  if (all_crmUsersId.length !== 0) {
    query = query.ilike("crm_user_name", all_crmUsersId);
  }
  if (lead_Type?.length !== 0) {
    console.log("lead_Type", lead_Type);
    if (lead_Type.includes("Direct")) {
      query = query.eq("leadtype", "Direct");
    }
    if (lead_Type.includes("CP")) {
      query = query.eq("leadtype", "CP");
    }
    if (lead_Type.includes("R&L")) {
      query = query.eq("leadtype", "R&L");
    }
  }

  if (all_sdr?.length !== 0) {
    if (all_sdr.includes("SDR Pending")) {
      const index = all_sdr.findIndex((v) => v === "SDR Pending");
      all_sdr?.splice(index, 1);
      all_sdr?.push(false);
    }

    if (all_sdr?.includes("SDR Complete")) {
      const index = all_sdr.findIndex((v) => v === "SDR Complete");
      all_sdr?.splice(index, 1);
      all_sdr?.push(true);
    }

    query = query.in("sdrcomplete", all_sdr);
  }

  if (all_av?.length !== 0) {
    if (all_av.includes("AV Changed")) {
      const index = all_av.findIndex((v) => v === "AV Changed");
      all_av?.splice(index, 1);
      all_av?.push(true);
    }

    if (all_av?.includes("AV Not Changed")) {
      const index = all_av.findIndex((v) => v === "AV Not Changed");
      all_av?.splice(index, 1);
      all_av?.push(false);
    }

    query = query.in("is_changeable_value", all_av);
  }

  if (all_agreement_kyc?.length !== 0) {
    if (all_agreement_kyc.includes("Agreement KYC Done")) {
      const index = all_agreement_kyc.findIndex(
        (v) => v === "Agreement KYC Done",
      );
      all_agreement_kyc?.splice(index, 1);
      all_agreement_kyc?.push(true);
    }

    if (all_agreement_kyc?.includes("Agreement KYC Pending")) {
      const index = all_agreement_kyc.findIndex(
        (v) => v === "Agreement KYC Pending",
      );
      all_agreement_kyc?.splice(index, 1);
      all_agreement_kyc?.push(false);
    }

    query = query.in("is_agreement_form_filled", all_agreement_kyc);
  }

  if (all_ocr?.length !== 0) {
    if (all_ocr.includes("Less than 10%")) {
      const index = all_ocr.findIndex((v) => v === "Less than 10%");
      all_ocr?.splice(index, 1);
      all_ocr?.push("less");
    }

    if (all_ocr?.includes("Greater than 10%")) {
      const index = all_ocr.findIndex((v) => v === "Greater than 10%");
      all_ocr?.splice(index, 1);
      all_ocr?.push("more");
    }

    if (all_ocr?.includes("Equals to 10%")) {
      const index = all_ocr.findIndex((v) => v === "Equals to 10%");
      all_ocr?.splice(index, 1);
      all_ocr?.push("equal");
    }

    query = query.in("isocrgreater", all_ocr);
  }

  if (all_sdr?.length !== 0) {
    if (all_sdr.includes("SDR Pending")) {
      const index = all_sdr.findIndex((v) => v === "SDR Pending");
      all_sdr?.splice(index, 1);
      all_sdr?.push(false);
    }

    if (all_sdr?.includes("SDR Complete")) {
      const index = all_sdr.findIndex((v) => v === "SDR Complete");
      all_sdr?.splice(index, 1);
      all_sdr?.push(true);
    }

    query = query.in("sdrcomplete", all_sdr);
  }

  if (all_projectId.length !== 0) {
    if (all_projectId[0]?.[0]?.["p"]?.length > 0) {
      query = query.in("project_id", all_projectId[0]?.[0]?.["p"]);
    }

    if (all_projectId[0]?.[0]?.["w"]?.length > 0) {
      query = query.in("wing_id", all_projectId[0]?.[0]?.["w"]);
    }

    if (all_projectId[0]?.[0]?.["f"]?.length > 0) {
      query = query.in("floor_no", all_projectId[0]?.[0]?.["f"]);
    }
  }

  if (all_status.length !== 0) {
    query = query.ilike("status", all_status);
  }

  if (requestPendingCrmUserId && requestPendingCrmUserId !== "") {
    query = query.eq("crmuserid", requestPendingCrmUserId);
  }
  if (!emailCount) {
    query = query.range(fromCount, toCount);
  }
  if (emailCount) {
    query = query.eq("isemailsent", true);
  }

  // execute RPC
  const { data: allotments, error } = await query;
  if (error) return { data: null, error };

  // STEP 1: Extract unique unit_ids from RPC result
  const unitIds = [
    ...new Set(
      allotments
        .map((a) => a.unit_id) // your RPC returns unit_id (snake_case)
        .filter(Boolean), // remove undefined/null
    ),
  ];

  // STEP 2: Fetch inventoryTypeId for every unit
  const { data: inventoryData } = await supabase
    .from("Inventory")
    .select("unitId, inventoryTypeId, jdBuId, jdWingId")
    .in("unitId", unitIds);

  // Map: unitId → inventoryTypeId
  const inventoryTypeMap = {};
  inventoryData?.forEach((inv) => {
    inventoryTypeMap[inv.unitId] = inv.inventoryTypeId;
  });

  // JD units read their config from the JD project + JD wing, not the VJ parent
  const jdConfigTargets = await getJdConfigTargetsForUnits(inventoryData, allotments);

  // STEP 3: Fetch ProjectAdditionalConfiguration
  const { data: projectConfigs } = await supabase
    .from("projectAdditionalConfiguration")
    .select("projectId, wingId, inventoryTypeId, isCommercial, gstPercentage");

  // Map: projectId-wingId-inventoryTypeId → { isCommercial, gstPercentage }
  const pacMap = {};
  projectConfigs?.forEach((cfg) => {
    const key = `${cfg.projectId}-${cfg.wingId}-${cfg.inventoryTypeId}`;
    pacMap[key] = { isCommercial: cfg.isCommercial, gstPercentage: cfg.gstPercentage };
  });

  // STEP 4: Merge everything into your RPC results
  const finalData = allotments.map((a) => {
    const inventoryTypeId = inventoryTypeMap[a.unit_id]; // match unit_id (RPC) → unitId (Inventory)

    const jdTarget = jdConfigTargets[a.unit_id];
    const key = jdTarget
        ? `${jdTarget.projectId}-${jdTarget.wingId}-${inventoryTypeId}`
        : `${a.project_id}-${a.wing_id}-${inventoryTypeId}`;
    const config = pacMap[key];

    return {
      ...a,
      inventoryTypeId,
      isCommercial: config?.isCommercial ?? null,
      // Only commercial rows carry a GST % override; non-commercial units
      // keep using the hardcoded 1%/5% GST rule client-side
      gstPercentage: config?.isCommercial ? config?.gstPercentage ?? null : null,
    };
  });

  return { data: finalData, error: null };
}

async function getChangedPlanCrmAllotments(
  requestPendingCrmUserId,
  pageNumber,
  search_lead_name,
  filterBy,
  checked = [],
  selectedDate,
  nextRange,
  isTableView,
  emailCount,
  ocrTagApproval,
  changeApplicantApproval,
) {
  let all_cpId = [];
  let all_projectId = [];
  let all_salesRepresentativeId = [];
  let all_status = [];
  let all_crmUsersId = [];
  let all_email = [];
  let all_sdr = [];
  let all_ocr = [];
  let lead_Type = [];
  let jsonParse;

  const limit = 10;
  const fromCount = isTableView ? nextRange?.from : pageNumber * limit;
  const toCount = isTableView
    ? nextRange?.to
    : pageNumber * limit + (limit - 1);

  // let query = supabase.from("CRM").select("*, crmUserId(*), requestPendingWith(*), allotmentPaymentId(*, userId(*),paymentId(*, eventId(*)),leadId(*, personId(*)), unitId(*, wingId(*), projectId(*), inventoryTypeId(*)), inventoryMergedId(*, unit1Id(*, wingId(*), projectId(*)), unit2Id(*)))", { count: "exact" });
  let query = supabase
    .rpc(
      "get_changed_plan_crm_allotments",
      { search_lead_name: search_lead_name },
      { count: "exact" },
    )
    .order(
      filterBy.includes("Name")
        ? "lead_name"
        : filterBy.includes("Unit")
          ? "unit_no"
          : "last_updated_at",
      {
        ascending:
          filterBy.includes("Oldest") || filterBy.includes("Ascending")
            ? true
            : false,
      },
    );
  console.log("rpc>>>>>>>>>>>>>>>>>>>>", query);

  // if (requestPendingCrmUserId && requestPendingCrmUserId !== "") {
  //   query = query.eq("requestPendingWith", requestPendingCrmUserId);
  // }

  if (checked && checked.length > 0) {
    checked.map((item) => {
      jsonParse = JSON.parse(item);
      if (jsonParse.filter == "CP") {
        all_cpId.push(jsonParse.value);
      } else if (jsonParse.filter == "Projects") {
        all_projectId.push(jsonParse.value);
      } else if (jsonParse.filter == "Users") {
        all_salesRepresentativeId.push(jsonParse.value);
      } else if (jsonParse.filter == "CrmUsers") {
        all_crmUsersId.push(jsonParse.value);
      } else if (jsonParse.filter == "Status") {
        all_status.push(jsonParse.value);
      } else if (jsonParse.filter == "Email") {
        all_email.push(jsonParse.value);
      } else if (jsonParse.filter === "SDR") {
        all_sdr.push(jsonParse.value);
      } else if (jsonParse.filter === "OCR") {
        all_ocr.push(jsonParse.value);
      } else if (jsonParse.filter === "Lead Type") {
        lead_Type.push(jsonParse.value);
      }
    });
  }

  // return

  if (
    selectedDate?.[0]?.value !== "" &&
    selectedDate?.[1]?.value !== "" &&
    selectedDate !== undefined
  ) {
    query = query
      .lte("created_at", Date.parse(new Date(selectedDate?.[1]?.value)))
      .gte("created_at", Date.parse(new Date(selectedDate?.[0]?.value)));
  }

  if (all_email.length !== 0) {
    if (all_email?.includes("Email Sent")) {
      const index = all_email.findIndex((v) => v === "Email Sent");
      all_email?.splice(index, 1);
      all_email?.push(true);
    }

    if (all_email?.includes("Email Not Sent")) {
      const index = all_email.findIndex((v) => v === "Email Not Sent");
      all_email?.splice(index, 1);
      all_email?.push(false);
    }
    query = query.in("isemailsent", all_email);
  }

  if (all_cpId.length !== 0) {
    query = query.ilike("cpname", all_cpId);
  }

  if (all_salesRepresentativeId.length !== 0) {
    query = query.ilike("sales_user_name", all_salesRepresentativeId);
  }

  if (all_crmUsersId.length !== 0) {
    query = query.ilike("crm_user_name", all_crmUsersId);
  }

  if (all_sdr?.length !== 0) {
    if (all_sdr.includes("SDR Pending")) {
      const index = all_sdr.findIndex((v) => v === "SDR Pending");
      all_sdr?.splice(index, 1);
      all_sdr?.push(false);
    }

    if (all_sdr?.includes("SDR Complete")) {
      const index = all_sdr.findIndex((v) => v === "SDR Complete");
      all_sdr?.splice(index, 1);
      all_sdr?.push(true);
    }

    query = query.in("sdrcomplete", all_sdr);
  }

  if (all_ocr?.length !== 0) {
    if (all_ocr.includes("Less than 10%")) {
      const index = all_ocr.findIndex((v) => v === "Less than 10%");
      all_ocr?.splice(index, 1);
      all_ocr?.push("less");
    }

    if (all_ocr?.includes("Greater than 10%")) {
      const index = all_ocr.findIndex((v) => v === "Greater than 10%");
      all_ocr?.splice(index, 1);
      all_ocr?.push("more");
    }

    if (all_ocr?.includes("Equals to 10%")) {
      const index = all_ocr.findIndex((v) => v === "Equals to 10%");
      all_ocr?.splice(index, 1);
      all_ocr?.push("equal");
    }

    query = query.in("isocrgreater", all_ocr);
  }

  if (all_projectId.length !== 0) {
    if (all_projectId[0]?.[0]?.["p"]?.length > 0) {
      query = query.in("project_id", all_projectId[0]?.[0]?.["p"]);
    }

    if (all_projectId[0]?.[0]?.["w"]?.length > 0) {
      query = query.in("wing_id", all_projectId[0]?.[0]?.["w"]);
    }

    if (all_projectId[0]?.[0]?.["f"]?.length > 0) {
      query = query.in("floor_no", all_projectId[0]?.[0]?.["f"]);
    }
  }

  if (lead_Type?.length !== 0) {
    console.log("lead_Type", lead_Type);
    if (lead_Type.includes("Direct")) {
      query = query.eq("leadtype", "Direct");
    }
    if (lead_Type.includes("CP")) {
      query = query.eq("leadtype", "CP");
    }
    if (lead_Type.includes("R&L")) {
      query = query.eq("leadtype", "R&L");
    }
  }

  if (all_status.length !== 0) {
    query = query.ilike("status", all_status);
  }

  if (requestPendingCrmUserId && requestPendingCrmUserId !== "") {
    query = query.eq("request_pending_with", requestPendingCrmUserId);
  }
  if (!emailCount) {
    query = query.range(fromCount, toCount);
  }
  if (emailCount) {
    query = query.eq("isemailsent", true);
  }
  if (ocrTagApproval) {
    query = query.eq("is_ocr_approved", false);
  }
  if (changeApplicantApproval) {
    query = query.eq("is_change_applicant_raised", false);
  }

  const approvalPendingData = await query;
  console.log(
    "returning final data in getChangedPlanCrmAllotments =======> ",
    approvalPendingData,
  );

  // ------------------------------------------------------------------------------------------
  const unitIds = [
    ...new Set(
      approvalPendingData.body
        .map((a) => a.unit_id) // your RPC returns unit_id (snake_case)
        .filter(Boolean), // remove undefined/null
    ),
  ];

  console.log("unitIds---------------->>>>>>", unitIds);
  // STEP 2: Fetch inventoryTypeId for every unit
  const { data: inventoryData } = await supabase
    .from("Inventory")
    .select("unitId, inventoryTypeId, jdBuId, jdWingId")
    .in("unitId", unitIds);
  console.log("inventoryData---------------->>>>>>", inventoryData);

  // Map: unitId → inventoryTypeId
  const inventoryTypeMap = {};
  inventoryData?.forEach((inv) => {
    inventoryTypeMap[inv.unitId] = inv.inventoryTypeId;
  });

  // JD units read their config from the JD project + JD wing, not the VJ parent
  const jdConfigTargets = await getJdConfigTargetsForUnits(inventoryData, approvalPendingData?.body);
  console.log("inventoryTypeMap---------------->>>>>>", inventoryTypeMap);

  // STEP 3: Fetch ProjectAdditionalConfiguration
  const { data: projectConfigs } = await supabase
    .from("projectAdditionalConfiguration")
    .select("projectId, wingId, inventoryTypeId, isCommercial, gstPercentage");
  console.log("projectConfigs---------------->>>>>>", projectConfigs);

  // Map: projectId-wingId-inventoryTypeId → { isCommercial, gstPercentage }
  const pacMap = {};
  projectConfigs?.forEach((cfg) => {
    const key = `${cfg.projectId}-${cfg.wingId}-${cfg.inventoryTypeId}`;
    pacMap[key] = { isCommercial: cfg.isCommercial, gstPercentage: cfg.gstPercentage };
  });

  // STEP 4: Merge everything into your RPC results
  const finalData = approvalPendingData?.body?.map((a) => {
    const inventoryTypeId = inventoryTypeMap[a.unit_id]; // match unit_id (RPC) → unitId (Inventory)

    const jdTarget = jdConfigTargets[a.unit_id];
    const key = jdTarget
        ? `${jdTarget.projectId}-${jdTarget.wingId}-${inventoryTypeId}`
        : `${a.project_id}-${a.wing_id}-${inventoryTypeId}`;
    const config = pacMap[key];

    return {
      ...a,
      inventoryTypeId,
      isCommercial: config?.isCommercial ?? null,
      // Only commercial rows carry a GST % override; non-commercial units
      // keep using the hardcoded 1%/5% GST rule client-side
      gstPercentage: config?.isCommercial ? config?.gstPercentage ?? null : null,
    };
  });
  console.log("type of finalData---------------->>>>>>", typeof finalData);
  console.log("finalData---------------->>>>>>", finalData);
  const finalApprovalPendingData = { data: finalData, error: null };
  console.log("finalFinalData---------------->>>>>>", finalApprovalPendingData);
  // ---------------------------------------------------------------------------------------------------------
  return finalApprovalPendingData;
}

async function getAgreementDoneCrmAllotments(
  requestPendingCrmUserId,
  pageNumber,
  search_lead_name,
  filterBy,
  checked = [],
  selectedDate,
  nextRange,
  isTableView,
  emailCount,
) {
  let all_cpId = [];
  let all_projectId = [];
  let all_salesRepresentativeId = [];
  let all_status = [];
  let all_crmUsersId = [];
  let all_email = [];
  let all_sdr = [];
  let all_ocr = [];
  let all_av = [];
  let all_agreement_kyc = [];
  let all_agreement_status = [];
  let sent_for_agreement = [];
  let lead_Type = [];
  let all_emandate_status = [];
  let jsonParse;

  const limit = 10;
  const fromCount = isTableView ? nextRange?.from : pageNumber * limit;
  const toCount = isTableView
    ? nextRange?.to
    : pageNumber * limit + (limit - 1);

  // let query = supabase.from("CRM").select("*, crmUserId(*), requestPendingWith(*), allotmentPaymentId(*, userId(*),paymentId(*, eventId(*)),leadId(*, personId(*)), unitId(*, wingId(*), projectId(*), inventoryTypeId(*)), inventoryMergedId(*, unit1Id(*, wingId(*), projectId(*)), unit2Id(*)))", { count: "exact" });
  let query = supabase
    .rpc(
      "get_agreement_done_crm_allotments_test",
      { search_lead_name: search_lead_name },
      { count: "exact" },
    )
    .order(
      filterBy.includes("Name")
        ? "lead_name"
        : filterBy.includes("Unit")
          ? "unit_no"
          : "last_updated_at",
      {
        ascending:
          filterBy.includes("Oldest") || filterBy.includes("Ascending")
            ? true
            : false,
      },
    );

  // if (requestPendingCrmUserId && requestPendingCrmUserId !== "") {
  //   query = query.eq("requestPendingWith", requestPendingCrmUserId);
  // }

  if (checked && checked.length > 0) {
    checked.map((item) => {
      jsonParse = JSON.parse(item);
      if (jsonParse.filter == "CP") {
        all_cpId.push(jsonParse.value);
      } else if (jsonParse.filter == "Projects") {
        all_projectId.push(jsonParse.value);
      } else if (jsonParse.filter == "Users") {
        all_salesRepresentativeId.push(jsonParse.value);
      } else if (jsonParse.filter == "CrmUsers") {
        all_crmUsersId.push(jsonParse.value);
      } else if (jsonParse.filter == "Status") {
        all_status.push(jsonParse.value);
      } else if (jsonParse.filter == "Email") {
        all_email.push(jsonParse.value);
      } else if (jsonParse.filter === "SDR") {
        all_sdr.push(jsonParse.value);
      } else if (jsonParse.filter === "OCR") {
        all_ocr.push(jsonParse.value);
      } else if (jsonParse.filter === "AV") {
        all_av.push(jsonParse.value);
      } else if (jsonParse.filter === "Agreement KYC") {
        all_agreement_kyc.push(jsonParse.value);
      } else if (jsonParse.filter === "Agreement Status") {
        all_agreement_status.push(jsonParse.value);
      } else if (jsonParse.filter === "Draft") {
        sent_for_agreement.push(jsonParse.value);
      } else if (jsonParse.filter === "Lead Type") {
        lead_Type.push(jsonParse.value);
      } else if (jsonParse.filter === "Emandate") {
        all_emandate_status.push(jsonParse.value);
      }
    });
  }

  // return

  if (
    selectedDate?.[0]?.value !== "" &&
    selectedDate?.[1]?.value !== "" &&
    selectedDate !== undefined
  ) {
    query = query
      .lte("created_at", Date.parse(new Date(selectedDate?.[1]?.value)))
      .gte("created_at", Date.parse(new Date(selectedDate?.[0]?.value)));
  }

  if (all_email.length !== 0) {
    if (all_email?.includes("Email Sent")) {
      const index = all_email.findIndex((v) => v === "Email Sent");
      all_email?.splice(index, 1);
      all_email?.push(true);
    }

    if (all_email?.includes("Email Not Sent")) {
      const index = all_email.findIndex((v) => v === "Email Not Sent");
      all_email?.splice(index, 1);
      all_email?.push(false);
    }
    query = query.in("isemailsent", all_email);
  }

  if (all_cpId.length !== 0) {
    query = query.ilike("cpname", all_cpId);
  }

  if (all_salesRepresentativeId.length !== 0) {
    query = query.ilike("sales_user_name", all_salesRepresentativeId);
  }

  if (all_crmUsersId.length !== 0) {
    query = query.ilike("crm_user_name", all_crmUsersId);
  }

  if (all_sdr?.length !== 0) {
    if (all_sdr.includes("SDR Pending")) {
      const index = all_sdr.findIndex((v) => v === "SDR Pending");
      all_sdr?.splice(index, 1);
      all_sdr?.push(false);
    }

    if (all_sdr?.includes("SDR Complete")) {
      const index = all_sdr.findIndex((v) => v === "SDR Complete");
      all_sdr?.splice(index, 1);
      all_sdr?.push(true);
    }

    query = query.in("sdrcomplete", all_sdr);
  }

  if (all_av?.length !== 0) {
    if (all_av.includes("AV Changed")) {
      const index = all_av.findIndex((v) => v === "AV Changed");
      all_av?.splice(index, 1);
      all_av?.push(true);
    }

    if (all_av?.includes("AV Not Changed")) {
      const index = all_av.findIndex((v) => v === "AV Not Changed");
      all_av?.splice(index, 1);
      all_av?.push(false);
    }

    query = query.in("is_changeable_value", all_av);
  }

  if (all_ocr?.length !== 0) {
    if (all_ocr.includes("Less than 10%")) {
      const index = all_ocr.findIndex((v) => v === "Less than 10%");
      all_ocr?.splice(index, 1);
      all_ocr?.push("less");
    }

    if (all_ocr?.includes("Greater than 10%")) {
      const index = all_ocr.findIndex((v) => v === "Greater than 10%");
      all_ocr?.splice(index, 1);
      all_ocr?.push("more");
    }

    if (all_ocr?.includes("Equals to 10%")) {
      const index = all_ocr.findIndex((v) => v === "Equals to 10%");
      all_ocr?.splice(index, 1);
      all_ocr?.push("equal");
    }

    query = query.in("isocrgreater", all_ocr);
  }

  if (all_agreement_kyc?.length !== 0) {
    if (all_agreement_kyc.includes("Agreement KYC Done")) {
      const index = all_agreement_kyc.findIndex(
        (v) => v === "Agreement KYC Done",
      );
      all_agreement_kyc?.splice(index, 1);
      all_agreement_kyc?.push(true);
    }

    if (all_agreement_kyc?.includes("Agreement KYC Pending")) {
      const index = all_agreement_kyc.findIndex(
        (v) => v === "Agreement KYC Pending",
      );
      all_agreement_kyc?.splice(index, 1);
      all_agreement_kyc?.push(false);
    }

    query = query.in("is_agreement_form_filled", all_agreement_kyc);
  }

  if (all_agreement_status?.length !== 0) {
    if (all_agreement_status.includes("Agreement Done")) {
      query = query.eq("status", "Agreement Done");
    }
    if (all_agreement_status.includes("Agreement Pending")) {
      query = query.neq("status", "Agreement Done");
    }
  }
  if (sent_for_agreement?.length !== 0) {
    if (sent_for_agreement.includes("Preview Agreement")) {
      const index = sent_for_agreement.findIndex(
        (v) => v === "Preview Agreement",
      );
      sent_for_agreement?.splice(index, 1);
      sent_for_agreement?.push(true);
    }

    if (sent_for_agreement?.includes("Create Draft Agreement")) {
      const index = sent_for_agreement.findIndex(
        (v) => v === "Create Draft Agreement",
      );
      sent_for_agreement?.splice(index, 1);
      sent_for_agreement?.push(false);
    }

    query = query.in("sent_for_agreement", sent_for_agreement);
  }
  if (lead_Type?.length !== 0) {
    console.log("lead_Type", lead_Type);
    if (lead_Type.includes("Direct")) {
      query = query.eq("leadtype", "Direct");
    }
    if (lead_Type.includes("CP")) {
      query = query.eq("leadtype", "CP");
    }
    if (lead_Type.includes("R&L")) {
      query = query.eq("leadtype", "R&L");
    }
  }

  //Emandate Filter
  if (all_emandate_status?.length !== 0) {
    if (all_emandate_status.includes("Pending")) {
      const index = all_emandate_status.findIndex((v) => v === "Pending");
      all_emandate_status?.splice(index, 1);
      all_emandate_status?.push("Pending");
    }
    if (all_emandate_status.includes("Partial")) {
      const index = all_emandate_status.findIndex((v) => v === "Partial");
      all_emandate_status?.splice(index, 1);
      all_emandate_status?.push("Partial");
    }
    if (all_emandate_status?.includes("Complete")) {
      const index = all_emandate_status.findIndex((v) => v === "Complete");
      all_emandate_status?.splice(index, 1);
      all_emandate_status?.push("Complete");
    }

    query = query.in("crmemandatestatus", all_emandate_status);
  }

  if (all_projectId.length !== 0) {
    if (all_projectId[0]?.[0]?.["p"]?.length > 0) {
      query = query.in("project_id", all_projectId[0]?.[0]?.["p"]);
    }

    if (all_projectId[0]?.[0]?.["w"]?.length > 0) {
      query = query.in("wing_id", all_projectId[0]?.[0]?.["w"]);
    }

    if (all_projectId[0]?.[0]?.["f"]?.length > 0) {
      query = query.in("floor_no", all_projectId[0]?.[0]?.["f"]);
    }
  }

  if (all_status.length !== 0) {
    query = query.ilike("status", all_status);
  }

  if (requestPendingCrmUserId && requestPendingCrmUserId !== "") {
    query = query.eq("crmuserid", requestPendingCrmUserId);
  }
  if (!emailCount) {
    query = query.range(fromCount, toCount);
  }
  if (emailCount) {
    query = query.eq("isemailsent", true);
  }
  return await query;
}

async function getParkingSelectionCrmAllotments(
  requestPendingCrmUserId,
  pageNumber,
  search_lead_name,
  filterBy,
  checked = [],
  selectedDate,
  nextRange,
  isTableView,
  emailCount,
) {
  let all_cpId = [];
  let all_projectId = [];
  let all_salesRepresentativeId = [];
  let all_status = [];
  let all_crmUsersId = [];
  let all_email = [];
  let all_sdr = [];
  let all_ocr = [];
  let all_av = [];
  let all_agreement_kyc = [];
  let lead_Type = [];
  let jsonParse;

  const limit = 10;
  const fromCount = isTableView ? nextRange?.from : pageNumber * limit;
  const toCount = isTableView
    ? nextRange?.to
    : pageNumber * limit + (limit - 1);

  // let query = supabase.from("CRM").select("*, crmUserId(*), requestPendingWith(*), allotmentPaymentId(*, userId(*),paymentId(*, eventId(*)),leadId(*, personId(*)), unitId(*, wingId(*), projectId(*), inventoryTypeId(*)), inventoryMergedId(*, unit1Id(*, wingId(*), projectId(*)), unit2Id(*)))", { count: "exact" });
  let query = supabase
    .rpc(
      "get_parking_selection_crm_allotments",
      { search_lead_name: search_lead_name },
      { count: "exact" },
    )
    .order(
      filterBy.includes("Name")
        ? "lead_name"
        : filterBy.includes("Unit")
          ? "unit_no"
          : "last_updated_at",
      {
        ascending:
          filterBy.includes("Oldest") || filterBy.includes("Ascending")
            ? true
            : false,
      },
    );

  // if (requestPendingCrmUserId && requestPendingCrmUserId !== "") {
  //   query = query.eq("requestPendingWith", requestPendingCrmUserId);
  // }

  if (checked && checked.length > 0) {
    checked.map((item) => {
      jsonParse = JSON.parse(item);
      if (jsonParse.filter == "CP") {
        all_cpId.push(jsonParse.value);
      } else if (jsonParse.filter == "Projects") {
        all_projectId.push(jsonParse.value);
      } else if (jsonParse.filter == "Users") {
        all_salesRepresentativeId.push(jsonParse.value);
      } else if (jsonParse.filter == "CrmUsers") {
        all_crmUsersId.push(jsonParse.value);
      } else if (jsonParse.filter == "Status") {
        all_status.push(jsonParse.value);
      } else if (jsonParse.filter == "Email") {
        all_email.push(jsonParse.value);
      } else if (jsonParse.filter === "SDR") {
        all_sdr.push(jsonParse.value);
      } else if (jsonParse.filter === "OCR") {
        all_ocr.push(jsonParse.value);
      } else if (jsonParse.filter === "AV") {
        all_av.push(jsonParse.value);
      } else if (jsonParse.filter === "Agreement KYC") {
        all_agreement_kyc.push(jsonParse.value);
      } else if (jsonParse.filter === "Lead Type") {
        lead_Type.push(jsonParse.value);
      }
    });
  }

  // return

  if (
    selectedDate?.[0]?.value !== "" &&
    selectedDate?.[1]?.value !== "" &&
    selectedDate !== undefined
  ) {
    query = query
      .lte("created_at", Date.parse(new Date(selectedDate?.[1]?.value)))
      .gte("created_at", Date.parse(new Date(selectedDate?.[0]?.value)));
  }

  if (all_email.length !== 0) {
    if (all_email?.includes("Email Sent")) {
      const index = all_email.findIndex((v) => v === "Email Sent");
      all_email?.splice(index, 1);
      all_email?.push(true);
    }

    if (all_email?.includes("Email Not Sent")) {
      const index = all_email.findIndex((v) => v === "Email Not Sent");
      all_email?.splice(index, 1);
      all_email?.push(false);
    }
    query = query.in("isemailsent", all_email);
  }

  if (all_cpId.length !== 0) {
    query = query.ilike("cpname", all_cpId);
  }

  if (all_salesRepresentativeId.length !== 0) {
    query = query.ilike("sales_user_name", all_salesRepresentativeId);
  }

  if (all_crmUsersId.length !== 0) {
    query = query.ilike("crm_user_name", all_crmUsersId);
  }

  if (all_sdr?.length !== 0) {
    if (all_sdr.includes("SDR Pending")) {
      const index = all_sdr.findIndex((v) => v === "SDR Pending");
      all_sdr?.splice(index, 1);
      all_sdr?.push(false);
    }

    if (all_sdr?.includes("SDR Complete")) {
      const index = all_sdr.findIndex((v) => v === "SDR Complete");
      all_sdr?.splice(index, 1);
      all_sdr?.push(true);
    }

    query = query.in("sdrcomplete", all_sdr);
  }

  if (lead_Type?.length !== 0) {
    console.log("lead_Type", lead_Type);
    if (lead_Type.includes("Direct")) {
      query = query.eq("leadtype", "Direct");
    }
    if (lead_Type.includes("CP")) {
      query = query.eq("leadtype", "CP");
    }
    if (lead_Type.includes("R&L")) {
      query = query.eq("leadtype", "R&L");
    }
  }

  if (all_av?.length !== 0) {
    if (all_av.includes("AV Changed")) {
      const index = all_av.findIndex((v) => v === "AV Changed");
      all_av?.splice(index, 1);
      all_av?.push(true);
    }

    if (all_av?.includes("AV Not Changed")) {
      const index = all_av.findIndex((v) => v === "AV Not Changed");
      all_av?.splice(index, 1);
      all_av?.push(false);
    }

    query = query.in("is_changeable_value", all_av);
  }

  if (all_ocr?.length !== 0) {
    if (all_ocr.includes("Less than 10%")) {
      const index = all_ocr.findIndex((v) => v === "Less than 10%");
      all_ocr?.splice(index, 1);
      all_ocr?.push("less");
    }

    if (all_ocr?.includes("Greater than 10%")) {
      const index = all_ocr.findIndex((v) => v === "Greater than 10%");
      all_ocr?.splice(index, 1);
      all_ocr?.push("more");
    }

    if (all_ocr?.includes("Equals to 10%")) {
      const index = all_ocr.findIndex((v) => v === "Equals to 10%");
      all_ocr?.splice(index, 1);
      all_ocr?.push("equal");
    }

    query = query.in("isocrgreater", all_ocr);
  }

  if (all_agreement_kyc?.length !== 0) {
    if (all_agreement_kyc.includes("Agreement KYC Done")) {
      const index = all_agreement_kyc.findIndex(
        (v) => v === "Agreement KYC Done",
      );
      all_agreement_kyc?.splice(index, 1);
      all_agreement_kyc?.push(true);
    }

    if (all_agreement_kyc?.includes("Agreement KYC Pending")) {
      const index = all_agreement_kyc.findIndex(
        (v) => v === "Agreement KYC Pending",
      );
      all_agreement_kyc?.splice(index, 1);
      all_agreement_kyc?.push(false);
    }

    query = query.in("is_agreement_form_filled", all_agreement_kyc);
  }

  if (all_projectId.length !== 0) {
    if (all_projectId[0]?.[0]?.["p"]?.length > 0) {
      query = query.in("project_id", all_projectId[0]?.[0]?.["p"]);
    }

    if (all_projectId[0]?.[0]?.["w"]?.length > 0) {
      query = query.in("wing_id", all_projectId[0]?.[0]?.["w"]);
    }

    if (all_projectId[0]?.[0]?.["f"]?.length > 0) {
      query = query.in("floor_no", all_projectId[0]?.[0]?.["f"]);
    }
  }

  if (all_status.length !== 0) {
    query = query.ilike("status", all_status);
  }

  if (requestPendingCrmUserId && requestPendingCrmUserId !== "") {
    query = query.eq("request_pending_with", requestPendingCrmUserId);
  }
  if (!emailCount) {
    query = query.range(fromCount, toCount);
  }
  if (emailCount) {
    query = query.eq("isemailsent", true);
  }
  return await query;
}

async function getUpdateSDRCrmAllotments(
  requestPendingCrmUserId,
  pageNumber,
  search_lead_name,
  filterBy,
  checked = [],
  selectedDate,
  nextRange,
  isTableView,
  emailCount,
) {
  let all_cpId = [];
  let all_projectId = [];
  let all_salesRepresentativeId = [];
  let all_status = [];
  let all_crmUsersId = [];
  let all_email = [];
  let all_sdr = [];
  let all_ocr = [];
  let all_av = [];
  let all_agreement_kyc = [];
  let lead_Type = [];
  let jsonParse;

  const limit = 10;
  const fromCount = isTableView ? nextRange?.from : pageNumber * limit;
  const toCount = isTableView
    ? nextRange?.to
    : pageNumber * limit + (limit - 1);

  // let query = supabase.from("CRM").select("*, crmUserId(*), requestPendingWith(*), allotmentPaymentId(*, userId(*),paymentId(*, eventId(*)),leadId(*, personId(*)), unitId(*, wingId(*), projectId(*), inventoryTypeId(*)), inventoryMergedId(*, unit1Id(*, wingId(*), projectId(*)), unit2Id(*)))", { count: "exact" });
  let query = supabase
    .rpc(
      "get_update_bucketing_crm_allotments_new",
      { search_lead_name: search_lead_name },
      { count: "exact" },
    )
    .order(
      filterBy.includes("Name")
        ? "lead_name"
        : filterBy.includes("Unit")
          ? "unit_no"
          : "last_updated_at",
      {
        ascending:
          filterBy.includes("Oldest") || filterBy.includes("Ascending")
            ? true
            : false,
      },
    );

  // if (requestPendingCrmUserId && requestPendingCrmUserId !== "") {
  //   query = query.eq("requestPendingWith", requestPendingCrmUserId);
  // }

  if (checked && checked.length > 0) {
    checked.map((item) => {
      jsonParse = JSON.parse(item);
      if (jsonParse.filter == "CP") {
        all_cpId.push(jsonParse.value);
      } else if (jsonParse.filter == "Projects") {
        all_projectId.push(jsonParse.value);
      } else if (jsonParse.filter == "Users") {
        all_salesRepresentativeId.push(jsonParse.value);
      } else if (jsonParse.filter == "CrmUsers") {
        all_crmUsersId.push(jsonParse.value);
      } else if (jsonParse.filter == "Status") {
        all_status.push(jsonParse.value);
      } else if (jsonParse.filter == "Email") {
        all_email.push(jsonParse.value);
      } else if (jsonParse.filter === "SDR") {
        all_sdr.push(jsonParse.value);
      } else if (jsonParse.filter === "OCR") {
        all_ocr.push(jsonParse.value);
      } else if (jsonParse.filter === "AV") {
        all_av.push(jsonParse.value);
      } else if (jsonParse.filter === "Agreement KYC") {
        all_agreement_kyc.push(jsonParse.value);
      } else if (jsonParse.filter === "Lead Type") {
        lead_Type.push(jsonParse.value);
      }
    });
  }

  // return

  if (
    selectedDate?.[0]?.value !== "" &&
    selectedDate?.[1]?.value !== "" &&
    selectedDate !== undefined
  ) {
    query = query
      .lte("created_at", Date.parse(new Date(selectedDate?.[1]?.value)))
      .gte("created_at", Date.parse(new Date(selectedDate?.[0]?.value)));
  }

  if (all_email.length !== 0) {
    if (all_email?.includes("Email Sent")) {
      const index = all_email.findIndex((v) => v === "Email Sent");
      all_email?.splice(index, 1);
      all_email?.push(true);
    }

    if (all_email?.includes("Email Not Sent")) {
      const index = all_email.findIndex((v) => v === "Email Not Sent");
      all_email?.splice(index, 1);
      all_email?.push(false);
    }
    query = query.in("isemailsent", all_email);
  }

  if (all_cpId.length !== 0) {
    query = query.ilike("cpname", all_cpId);
  }

  if (all_salesRepresentativeId.length !== 0) {
    query = query.ilike("sales_user_name", all_salesRepresentativeId);
  }

  if (all_crmUsersId.length !== 0) {
    query = query.ilike("crm_user_name", all_crmUsersId);
  }

  if (all_sdr?.length !== 0) {
    if (all_sdr.includes("SDR Pending")) {
      const index = all_sdr.findIndex((v) => v === "SDR Pending");
      all_sdr?.splice(index, 1);
      all_sdr?.push(false);
    }

    if (all_sdr?.includes("SDR Complete")) {
      const index = all_sdr.findIndex((v) => v === "SDR Complete");
      all_sdr?.splice(index, 1);
      all_sdr?.push(true);
    }

    query = query.in("sdrcomplete", all_sdr);
  }

  if (all_av?.length !== 0) {
    if (all_av.includes("AV Changed")) {
      const index = all_av.findIndex((v) => v === "AV Changed");
      all_av?.splice(index, 1);
      all_av?.push(true);
    }

    if (all_av?.includes("AV Not Changed")) {
      const index = all_av.findIndex((v) => v === "AV Not Changed");
      all_av?.splice(index, 1);
      all_av?.push(false);
    }

    query = query.in("is_changeable_value", all_av);
  }

  if (all_ocr?.length !== 0) {
    if (all_ocr.includes("Less than 10%")) {
      const index = all_ocr.findIndex((v) => v === "Less than 10%");
      all_ocr?.splice(index, 1);
      all_ocr?.push("less");
    }

    if (all_ocr?.includes("Greater than 10%")) {
      const index = all_ocr.findIndex((v) => v === "Greater than 10%");
      all_ocr?.splice(index, 1);
      all_ocr?.push("more");
    }

    if (all_ocr?.includes("Equals to 10%")) {
      const index = all_ocr.findIndex((v) => v === "Equals to 10%");
      all_ocr?.splice(index, 1);
      all_ocr?.push("equal");
    }

    query = query.in("isocrgreater", all_ocr);
  }

  if (all_agreement_kyc?.length !== 0) {
    if (all_agreement_kyc.includes("Agreement KYC Done")) {
      const index = all_agreement_kyc.findIndex(
        (v) => v === "Agreement KYC Done",
      );
      all_agreement_kyc?.splice(index, 1);
      all_agreement_kyc?.push(true);
    }

    if (all_agreement_kyc?.includes("Agreement KYC Pending")) {
      const index = all_agreement_kyc.findIndex(
        (v) => v === "Agreement KYC Pending",
      );
      all_agreement_kyc?.splice(index, 1);
      all_agreement_kyc?.push(false);
    }

    query = query.in("is_agreement_form_filled", all_agreement_kyc);
  }
  if (lead_Type?.length !== 0) {
    console.log("lead_Type", lead_Type);
    if (lead_Type.includes("Direct")) {
      query = query.eq("leadtype", "Direct");
    }
    if (lead_Type.includes("CP")) {
      query = query.eq("leadtype", "CP");
    }
    if (lead_Type.includes("R&L")) {
      query = query.eq("leadtype", "R&L");
    }
  }
  if (all_sdr?.length !== 0) {
    if (all_sdr.includes("SDR Pending")) {
      const index = all_sdr.findIndex((v) => v === "SDR Pending");
      all_sdr?.splice(index, 1);
      all_sdr?.push(false);
    }

    if (all_sdr?.includes("SDR Complete")) {
      const index = all_sdr.findIndex((v) => v === "SDR Complete");
      all_sdr?.splice(index, 1);
      all_sdr?.push(true);
    }

    query = query.in("sdrcomplete", all_sdr);
  }

  if (all_projectId.length !== 0) {
    if (all_projectId[0]?.[0]?.["p"]?.length > 0) {
      query = query.in("project_id", all_projectId[0]?.[0]?.["p"]);
    }

    if (all_projectId[0]?.[0]?.["w"]?.length > 0) {
      query = query.in("wing_id", all_projectId[0]?.[0]?.["w"]);
    }

    if (all_projectId[0]?.[0]?.["f"]?.length > 0) {
      query = query.in("floor_no", all_projectId[0]?.[0]?.["f"]);
    }
  }

  if (all_status.length !== 0) {
    query = query.ilike("status", all_status);
  }

  if (requestPendingCrmUserId && requestPendingCrmUserId !== "") {
    query = query.eq("request_pending_with", requestPendingCrmUserId);
  }
  if (!emailCount) {
    query = query.range(fromCount, toCount);
  }
  if (emailCount) {
    query = query.eq("isemailsent", true);
  }
  return await query;
}

//todo ----> for Tab 4
async function getCompletedCrmAllotments(
  requestPendingCrmUserId,
  pageNumber,
  search_lead_name,
  filterBy,
  checked = [],
  selectedDate,
  nextRange,
  isTableView,
  emailCount,
) {
  let all_cpId = [];
  let all_projectId = [];
  let all_salesRepresentativeId = [];
  let all_status = [];
  let all_crmUsersId = [];
  let all_email = [];
  let all_sdr = [];
  let all_ocr = [];
  let all_av = [];
  let all_agreement_kyc = [];
  let lead_Type = [];
  let all_emandate_status = [];
  let jsonParse;

  const limit = 10;
  const fromCount = isTableView ? nextRange?.from : pageNumber * limit;
  const toCount = isTableView
    ? nextRange?.to
    : pageNumber * limit + (limit - 1);

  // let query = supabase.from("CRM").select("*, crmUserId(*), requestPendingWith(*), allotmentPaymentId(*, userId(*),paymentId(*, eventId(*)),leadId(*, personId(*)), unitId(*, wingId(*), projectId(*), inventoryTypeId(*)), inventoryMergedId(*, unit1Id(*, wingId(*), projectId(*)), unit2Id(*)))", { count: "exact" });
  let query = supabase
    .rpc(
      "get_completed_crm_allotment_test",
      { search_lead_name: search_lead_name },
      { count: "exact" },
    )
    .order(
      filterBy.includes("Name")
        ? "lead_name"
        : filterBy.includes("Unit")
          ? "unit_no"
          : "last_updated_at",
      {
        ascending:
          filterBy.includes("Oldest") || filterBy.includes("Ascending")
            ? true
            : false,
      },
    );

  // if (requestPendingCrmUserId && requestPendingCrmUserId !== "") {
  //   query = query.eq("requestPendingWith", requestPendingCrmUserId);
  // }

  if (checked && checked.length > 0) {
    checked.map((item) => {
      jsonParse = JSON.parse(item);
      if (jsonParse.filter == "CP") {
        all_cpId.push(jsonParse.value);
      } else if (jsonParse.filter == "Projects") {
        all_projectId.push(jsonParse.value);
      } else if (jsonParse.filter == "Users") {
        all_salesRepresentativeId.push(jsonParse.value);
      } else if (jsonParse.filter == "CrmUsers") {
        all_crmUsersId.push(jsonParse.value);
      } else if (jsonParse.filter == "Status") {
        all_status.push(jsonParse.value);
      } else if (jsonParse.filter == "Email") {
        all_email.push(jsonParse.value);
      } else if (jsonParse.filter === "SDR") {
        all_sdr.push(jsonParse.value);
      } else if (jsonParse.filter === "OCR") {
        all_ocr.push(jsonParse.value);
      } else if (jsonParse.filter === "AV") {
        all_av.push(jsonParse.value);
      } else if (jsonParse.filter === "Agreement KYC") {
        all_agreement_kyc.push(jsonParse.value);
      } else if (jsonParse.filter === "Lead Type") {
        lead_Type.push(jsonParse.value);
      } else if (jsonParse.filter == "Emandate") {
        all_emandate_status.push(jsonParse.value);
      }
    });
  }

  // return

  if (
    selectedDate?.[0]?.value !== "" &&
    selectedDate?.[1]?.value !== "" &&
    selectedDate !== undefined
  ) {
    query = query
      .lte("created_at", Date.parse(new Date(selectedDate?.[1]?.value)))
      .gte("created_at", Date.parse(new Date(selectedDate?.[0]?.value)));
  }

  if (all_email.length !== 0) {
    if (all_email?.includes("Email Sent")) {
      const index = all_email.findIndex((v) => v === "Email Sent");
      all_email?.splice(index, 1);
      all_email?.push(true);
    }

    if (all_email?.includes("Email Not Sent")) {
      const index = all_email.findIndex((v) => v === "Email Not Sent");
      all_email?.splice(index, 1);
      all_email?.push(false);
    }
    query = query.in("isemailsent", all_email);
  }

  //Emandate filters
  if (all_emandate_status?.length !== 0) {
    if (all_emandate_status.includes("Pending")) {
      const index = all_emandate_status.findIndex((v) => v === "Pending");
      all_emandate_status?.splice(index, 1);
      all_emandate_status?.push("Pending");
    }
    if (all_emandate_status.includes("Partial")) {
      const index = all_emandate_status.findIndex((v) => v === "Partial");
      all_emandate_status?.splice(index, 1);
      all_emandate_status?.push("Partial");
    }
    if (all_emandate_status?.includes("Complete")) {
      const index = all_emandate_status.findIndex((v) => v === "Complete");
      all_emandate_status?.splice(index, 1);
      all_emandate_status?.push("Complete");
    }

    query = query.in("crmemandatestatus", all_emandate_status);
  }

  if (all_cpId.length !== 0) {
    query = query.ilike("cpname", all_cpId);
  }

  if (all_salesRepresentativeId.length !== 0) {
    query = query.ilike("sales_user_name", all_salesRepresentativeId);
  }

  if (all_crmUsersId.length !== 0) {
    query = query.ilike("crm_user_name", all_crmUsersId);
  }

  if (all_sdr?.length !== 0) {
    if (all_sdr.includes("SDR Pending")) {
      const index = all_sdr.findIndex((v) => v === "SDR Pending");
      all_sdr?.splice(index, 1);
      all_sdr?.push(false);
    }

    if (all_sdr?.includes("SDR Complete")) {
      const index = all_sdr.findIndex((v) => v === "SDR Complete");
      all_sdr?.splice(index, 1);
      all_sdr?.push(true);
    }

    query = query.in("sdrcomplete", all_sdr);
  }

  if (all_av?.length !== 0) {
    if (all_av.includes("AV Changed")) {
      const index = all_av.findIndex((v) => v === "AV Changed");
      all_av?.splice(index, 1);
      all_av?.push(true);
    }

    if (all_av?.includes("AV Not Changed")) {
      const index = all_av.findIndex((v) => v === "AV Not Changed");
      all_av?.splice(index, 1);
      all_av?.push(false);
    }

    query = query.in("is_changeable_value", all_av);
  }

  if (all_ocr?.length !== 0) {
    if (all_ocr.includes("Less than 10%")) {
      const index = all_ocr.findIndex((v) => v === "Less than 10%");
      all_ocr?.splice(index, 1);
      all_ocr?.push("less");
    }

    if (all_ocr?.includes("Greater than 10%")) {
      const index = all_ocr.findIndex((v) => v === "Greater than 10%");
      all_ocr?.splice(index, 1);
      all_ocr?.push("more");
    }

    if (all_ocr?.includes("Equals to 10%")) {
      const index = all_ocr.findIndex((v) => v === "Equals to 10%");
      all_ocr?.splice(index, 1);
      all_ocr?.push("equal");
    }

    query = query.in("isocrgreater", all_ocr);
  }

  if (all_agreement_kyc?.length !== 0) {
    if (all_agreement_kyc.includes("Agreement KYC Done")) {
      const index = all_agreement_kyc.findIndex(
        (v) => v === "Agreement KYC Done",
      );
      all_agreement_kyc?.splice(index, 1);
      all_agreement_kyc?.push(true);
    }

    if (all_agreement_kyc?.includes("Agreement KYC Pending")) {
      const index = all_agreement_kyc.findIndex(
        (v) => v === "Agreement KYC Pending",
      );
      all_agreement_kyc?.splice(index, 1);
      all_agreement_kyc?.push(false);
    }

    query = query.in("is_agreement_form_filled", all_agreement_kyc);
  }

  if (lead_Type?.length !== 0) {
    console.log("lead_Type", lead_Type);
    if (lead_Type.includes("Direct")) {
      query = query.eq("leadtype", "Direct");
    }
    if (lead_Type.includes("CP")) {
      query = query.eq("leadtype", "CP");
    }
    if (lead_Type.includes("R&L")) {
      query = query.eq("leadtype", "R&L");
    }
  }
  if (all_projectId.length !== 0) {
    if (all_projectId[0]?.[0]?.["p"]?.length > 0) {
      query = query.in("project_id", all_projectId[0]?.[0]?.["p"]);
    }

    if (all_projectId[0]?.[0]?.["w"]?.length > 0) {
      query = query.in("wing_id", all_projectId[0]?.[0]?.["w"]);
    }

    if (all_projectId[0]?.[0]?.["f"]?.length > 0) {
      query = query.in("floor_no", all_projectId[0]?.[0]?.["f"]);
    }
  }

  if (all_status.length !== 0) {
    query = query.ilike("status", all_status);
  }

  if (requestPendingCrmUserId && requestPendingCrmUserId !== "") {
    query = query.eq("request_pending_with", requestPendingCrmUserId);
  }
  if (!emailCount) {
    query = query.range(fromCount, toCount);
  }
  if (emailCount) {
    query = query.eq("isemailsent", true);
  }
  return await query;
}

async function getCancellationsCrmAllotments(
  requestPendingCrmUserId,
  pageNumber,
  search_lead_name,
  filterBy,
  checked = [],
  selectedDate,
  nextRange,
  isTableView,
  emailCount,
) {
  let all_cpId = [];
  let all_projectId = [];
  let all_salesRepresentativeId = [];
  let all_status = [];
  let all_crmUsersId = [];
  let all_email = [];
  let all_sdr = [];
  let all_ocr = [];
  let all_av = [];
  let lead_Type = [];
  let jsonParse;

  const limit = 10;
  const fromCount = isTableView ? nextRange?.from : pageNumber * limit;
  const toCount = isTableView
    ? nextRange?.to
    : pageNumber * limit + (limit - 1);

  // let query = supabase.from("CRM").select("*, crmUserId(*), requestPendingWith(*), allotmentPaymentId(*, userId(*),paymentId(*, eventId(*)),leadId(*, personId(*)), unitId(*, wingId(*), projectId(*), inventoryTypeId(*)), inventoryMergedId(*, unit1Id(*, wingId(*), projectId(*)), unit2Id(*)))", { count: "exact" });
  let query = supabase
    .rpc(
      "get_cancelled_and_refund_allotment",
      { search_lead_name: search_lead_name },
      { count: "exact" },
    )
    .order(
      filterBy.includes("Name")
        ? "lead_name"
        : filterBy.includes("Unit")
          ? "unit_no"
          : "last_updated_at",
      {
        ascending:
          filterBy.includes("Oldest") || filterBy.includes("Ascending")
            ? true
            : false,
      },
    );

  // if (requestPendingCrmUserId && requestPendingCrmUserId !== "") {
  //   query = query.eq("requestPendingWith", requestPendingCrmUserId);
  // }

  if (checked && checked.length > 0) {
    checked.map((item) => {
      jsonParse = JSON.parse(item);
      if (jsonParse.filter == "CP") {
        all_cpId.push(jsonParse.value);
      } else if (jsonParse.filter == "Projects") {
        all_projectId.push(jsonParse.value);
      } else if (jsonParse.filter == "Users") {
        all_salesRepresentativeId.push(jsonParse.value);
      } else if (jsonParse.filter == "CrmUsers") {
        all_crmUsersId.push(jsonParse.value);
      } else if (jsonParse.filter == "Status") {
        all_status.push(jsonParse.value);
      } else if (jsonParse.filter == "Email") {
        all_email.push(jsonParse.value);
      } else if (jsonParse.filter === "SDR") {
        all_sdr.push(jsonParse.value);
      } else if (jsonParse.filter === "OCR") {
        all_ocr.push(jsonParse.value);
      } else if (jsonParse.filter === "AV") {
        all_av.push(jsonParse.value);
      } else if (jsonParse.filter === "Lead Type") {
        lead_Type.push(jsonParse.value);
      }
    });
  }

  // return

  if (
    selectedDate?.[0]?.value !== "" &&
    selectedDate?.[1]?.value !== "" &&
    selectedDate !== undefined
  ) {
    query = query
      .lte("created_at", Date.parse(new Date(selectedDate?.[1]?.value)))
      .gte("created_at", Date.parse(new Date(selectedDate?.[0]?.value)));
  }

  if (all_email.length !== 0) {
    if (all_email?.includes("Email Sent")) {
      const index = all_email.findIndex((v) => v === "Email Sent");
      all_email?.splice(index, 1);
      all_email?.push(true);
    }

    if (all_email?.includes("Email Not Sent")) {
      const index = all_email.findIndex((v) => v === "Email Not Sent");
      all_email?.splice(index, 1);
      all_email?.push(false);
    }
    query = query.in("isemailsent", all_email);
  }

  if (all_cpId.length !== 0) {
    query = query.ilike("cpname", all_cpId);
  }

  if (all_salesRepresentativeId.length !== 0) {
    query = query.ilike("sales_user_name", all_salesRepresentativeId);
  }

  if (all_crmUsersId.length !== 0) {
    query = query.ilike("crm_user_name", all_crmUsersId);
  }

  if (all_sdr?.length !== 0) {
    if (all_sdr.includes("SDR Pending")) {
      const index = all_sdr.findIndex((v) => v === "SDR Pending");
      all_sdr?.splice(index, 1);
      all_sdr?.push(false);
    }

    if (all_sdr?.includes("SDR Complete")) {
      const index = all_sdr.findIndex((v) => v === "SDR Complete");
      all_sdr?.splice(index, 1);
      all_sdr?.push(true);
    }

    query = query.in("sdrcomplete", all_sdr);
  }

  if (all_av?.length !== 0) {
    if (all_av.includes("AV Changed")) {
      const index = all_av.findIndex((v) => v === "AV Changed");
      all_av?.splice(index, 1);
      all_av?.push(true);
    }

    if (all_av?.includes("AV Not Changed")) {
      const index = all_av.findIndex((v) => v === "AV Not Changed");
      all_av?.splice(index, 1);
      all_av?.push(false);
    }

    query = query.in("is_changeable_value", all_av);
  }

  if (all_ocr?.length !== 0) {
    if (all_ocr.includes("Less than 10%")) {
      const index = all_ocr.findIndex((v) => v === "Less than 10%");
      all_ocr?.splice(index, 1);
      all_ocr?.push("less");
    }

    if (all_ocr?.includes("Greater than 10%")) {
      const index = all_ocr.findIndex((v) => v === "Greater than 10%");
      all_ocr?.splice(index, 1);
      all_ocr?.push("more");
    }

    if (all_ocr?.includes("Equals to 10%")) {
      const index = all_ocr.findIndex((v) => v === "Equals to 10%");
      all_ocr?.splice(index, 1);
      all_ocr?.push("equal");
    }

    query = query.in("isocrgreater", all_ocr);
  }

  if (all_projectId.length !== 0) {
    if (all_projectId[0]?.[0]?.["p"]?.length > 0) {
      query = query.in("project_id", all_projectId[0]?.[0]?.["p"]);
    }

    if (all_projectId[0]?.[0]?.["w"]?.length > 0) {
      query = query.in("wing_id", all_projectId[0]?.[0]?.["w"]);
    }

    if (all_projectId[0]?.[0]?.["f"]?.length > 0) {
      query = query.in("floor_no", all_projectId[0]?.[0]?.["f"]);
    }
  }

  if (all_status.length !== 0) {
    query = query.ilike("status", all_status);
  }
  if (lead_Type?.length !== 0) {
    console.log("lead_Type", lead_Type);
    if (lead_Type.includes("Direct")) {
      query = query.eq("leadtype", "Direct");
    }
    if (lead_Type.includes("CP")) {
      query = query.eq("leadtype", "CP");
    }
    if (lead_Type.includes("R&L")) {
      query = query.eq("leadtype", "R&L");
    }
  }
  if (requestPendingCrmUserId && requestPendingCrmUserId !== "") {
    query = query.eq("request_pending_with", requestPendingCrmUserId);
  }
  if (!emailCount) {
    query = query.range(fromCount, toCount);
  }
  if (emailCount) {
    query = query.eq("isemailsent", true);
  }
  return await query;
}

async function approveCrmAllotment(crmAllotmentId) {
  return await supabase
    .from("CRM")
    .update({ isApproved: true, isRejectChanges: false, rejectionReason: "" })
    .eq("id", crmAllotmentId)
    .select("*")
    .maybeSingle();
}
async function approveTagCrmAllotment(crmAllotmentId) {
  return await supabase
    .from("CRM")
    .update({
      isTagApprove: true,
      crmStatusId: process.env.REACT_APP_CHANGE_AV,
      last_updated_at: Date.now(),
    })
    .eq("id", crmAllotmentId)
    .select("*")
    .maybeSingle();
}

async function updateParkingSelectionFlag(crmAllotmentId) {
  return await supabase
    .from("CRM")
    .update({
      isParkingSelectionSubmitted: true,
      crmStatusId: process.env.REACT_APP_AGREEMENT,
      last_updated_at: Date.now(),
    })
    .eq("id", crmAllotmentId)
    .select("*")
    .maybeSingle();
}

async function getParkingNumbersFromParkingInventory(projectId, parkingTypeId) {
  return await supabase
    .from("ParkingInventory")
    .select("*, parkingTypeId(*)")
    .eq("projectId", projectId)
    .eq("parkingTypeId", parkingTypeId);
}

async function getParkingTypes(projectId) {
  return await supabase
    .from("ParkingInventory")
    .select("parkingTypeId(*)")
    .eq("projectId", projectId);
}

async function fetchSelectedParkingNumbers(allotmentPaymentId) {
  const { data, error } = await supabase
    .from("ParkingSelection")
    .select("*, parkingInventoryId(*, parkingTypeId(*))")
    .eq("allotmentPaymentId", allotmentPaymentId);
  if (data) return { data };
  else throw error;
}

async function sendForOcrApproval(crmAllotmentId, userId) {
  return await supabase
    .from("CRM")
    .update({
      crmStatusId: process.env.REACT_APP_APPROVAL_PENDING,
      isOcrApproved: false,
      requestPendingWith: userId,
      last_updated_at: Date.now(),
    })
    .eq("id", crmAllotmentId)
    .select("*")
    .maybeSingle();
}

async function moveToAgreementAfterOcrApproval(crmAllotmentId, userId) {
  return await supabase
    .from("CRM")
    .update({
      crmStatusId: process.env.REACT_APP_AGREEMENT,
      isOcrApproved: true,
      requestPendingWith: userId,
      last_updated_at: Date.now(),
    })
    .eq("id", crmAllotmentId)
    .select("*")
    .maybeSingle();
}

async function approveChangeApplicantRequestCRM(
  crmAllotmentId,
  userId,
  changeApplicantCrmStatusId,
) {
  return await supabase
    .from("CRM")
    .update({
      crmStatusId: changeApplicantCrmStatusId,
      requestPendingWith: userId,
      last_updated_at: Date.now(),
    })
    .eq("id", crmAllotmentId)
    .select("*")
    .maybeSingle();
}

async function approveChangeApplicantRequest(changeApplicantRequestId) {
  return await supabase
    .from("ChangeApplicantRequests")
    .update({ status: "accepted" })
    .eq("changeApplicantRequestId", changeApplicantRequestId)
    .select("*")
    .maybeSingle();
}

async function approveTagCrmAllotmentCreateApplication(allotmentPaymentId) {
  // return await axios.post('http://192.168.2.113:8000/scheduler/createApplication', { allotmentPaymentId });
  return await axios.post(
    `${process.env.REACT_APP_PAYMENT_LINK_URL}scheduler/createApplication`,
    { allotmentPaymentId },
  );
}

async function rejectTagCrmAllotment(crmAllotmentId) {
  return await supabase
    .from("CRM")
    .delete()
    .eq("id", crmAllotmentId)
    .select("*")
    .maybeSingle();
}

async function sendWelcomePdf(
  crmAllotmentId,
  emailId,
  getPdfOnly,
  PNRDAllotmentLetterBase64,
) {
  // return await axios.post("http://192.168.2.65:8053/allotment/sendMailWithWelcomePdfAndCrmProfilePdf", {
  // 	crmAllotmentId,
  // 	emailId,
  // 	getPdfOnly: getPdfOnly,
  // });
  console.log(
    "PNRDAllotmentLetterBase64Alllotment>>>>>>>>",
    PNRDAllotmentLetterBase64,
  );
  return await axios.post(
    `${process.env.REACT_APP_PAYMENT_LINK_URL}allotment/sendMailWithWelcomePdfAndCrmProfilePdf`,
    {
      crmAllotmentId,
      emailId,
      getPdfOnly: getPdfOnly,
      PNRDAllotmentLetterBase64,
      // isNewUi: true
    },
  );
}

async function updateCrmAllotment(postBody, crmAllotmentId) {
  const payload = { ...postBody, last_updated_at: Date.now() };
  return await supabase
    .from("CRM")
    .update(payload)
    .eq("id", crmAllotmentId)
    .select("*")
    .maybeSingle();
}

async function getLegalCharges(projectId) {
  return await supabase
    .from("Projects")
    .select("legalCharges")
    .eq("projectId", projectId)
    .maybeSingle();
}

async function getTokensByLeadId(leadId, paymentId) {
  // return await supabase.from("EventTokenLeadRelations").select('*,eventId(*),linkedTokenId(*,eventTokenId(*,tokenId(*))),eventTokenId(*,tokenId(*))').eq("leadId", leadId).in('status', ['active', 'alloted']).eq('isPrerequisiteUsed', false);
  if (paymentId === "") {
    return await supabase
      .from("EventTokenLeadRelations")
      .select(
        "*,eventId(*),linkedTokenId(*,eventTokenId(*,tokenId(*))),eventTokenId(*,tokenId(*))",
      )
      .eq("leadId", leadId)
      // .eq("status", "active")
      .eq("isPrerequisiteUsed", false);
  } else {
    let active = await supabase
      .from("EventTokenLeadRelations")
      .select(
        "*,eventId(*),linkedTokenId(*,eventTokenId(*,tokenId(*))),eventTokenId(*,tokenId(*))",
      )
      .eq("leadId", leadId)
      // .eq("status", "active")
      .eq("isPrerequisiteUsed", false);
    // let alloted = await supabase
    //   .from("EventTokenLeadRelations")
    //   .select(
    //     "*,eventId(*),linkedTokenId(*,eventTokenId(*,tokenId(*))),eventTokenId(*,tokenId(*))"
    //   )
    //   .eq("leadId", leadId)
    //   .eq(`status`, "alloted")
    //   .eq("paymentId", paymentId)
    //   .eq("isPrerequisiteUsed", false);
    return { data: [...active.data] };
  }
}

async function insertTransactionLogs(obj) {
  const { data, error, count } = await supabase
    .from("AllotmentTransactionsLogs")
    .insert(obj);
  if (data) return { data };
  else throw error;
}

async function getVirtualAccDetailsById(leadDisplayId) {
  const { data, count, error } = await supabase
    .from("Leads")
    .select("virtualAccId")
    .eq("leadDisplayId", leadDisplayId);
  if (data) return { data, count };
  else throw error;
}

//Aggrement id

async function getAggrementId(allotmentPaymentId) {
  const { data, error } = await supabase
    .from("AgreementForm")
    .select('*,nbfcId("*"),bankId("*")')
    .eq("allotmentPaymentId", allotmentPaymentId);

  if (data) return { data };
  else throw error;
}

async function getApplicantId(agreementId) {
  const { data, error } = await supabase
    .from("Applicants")
    .select("*")
    .eq("agreementFormId", agreementId);
  if (data) return { data };
  else throw error;
}

async function getCRMTimelineData(allotmentPaymentId) {
  // CRM2 M1.17: also the name of who did it (CRMLogs.userId → Users.name) as "actor".
  const { data, error } = await supabase
    .from("CRMLogs")
    .select("*, actor:userId(name)")
    .eq("allotmentPaymentId", allotmentPaymentId)
    .order("created_at", { ascending: false });
  if (data) return { data };
  else throw error;
}

async function getLeadIdForCRMUser(allotmentPaymentId) {
  const { data, error } = await supabase
    .from("AllotmentPayment")
    .select("leadId(leadId)")
    .eq("allotmentPaymentId", allotmentPaymentId);
  if (data) return { data };
  else throw error;
}

async function getChangeApplicantById(agreementFormId) {
  return await supabase
    .from("ChangeApplicantRequests")
    .select("*")
    .eq("agreementFormId", agreementFormId);
}

async function updateSkipDraftDetailsInCRM(crmAllotmentId) {
  const { data, error } = await supabase
    .from("CRM")
    .update({ skipCreateDraft: true })
    .eq("id", crmAllotmentId)
    .select("*")
    .maybeSingle();
  if (data) return { data };
  else throw error;
}

async function uploadAgreementReceipt(file, allotmentPaymentId) {
  const fileExt = file?.name?.split(".").pop();
  const filePath = `agreement_receipts/${allotmentPaymentId}.${fileExt}`;
  const uploadResponse = await supabase.storage
    .from("AgreementKYCDocuments")
    .upload(filePath, file, { upsert: true });
  if (uploadResponse?.error) throw uploadResponse.error;
  const publicURL = supabase.storage
    .from("AgreementKYCDocuments")
    .getPublicUrl(filePath).data.publicURL;
  return publicURL;
}


// Returns { allotmentPaymentId, agreementStatus } rows for the given allotment ids,
// used to tell which allotments already have their agreement entry filled.
async function getAgreementStatusByAllotmentIds(allotmentPaymentIds) {
  if (!allotmentPaymentIds || allotmentPaymentIds.length === 0) return [];
  const { data, error } = await supabase
    .from("AgreementForm")
    .select("allotmentPaymentId, agreementStatus")
    .in("allotmentPaymentId", allotmentPaymentIds);
  if (error) throw error;
  return data || [];
}

async function getPreviewAgreementToCustomer(id) {
  var query;
  query = supabase
    .from("CRM")
    .select("isPreviewAgreementEnable")
    .eq("id", id)
    .maybeSingle();
  const { data, error } = await query;
  if (data) return { data };
  else throw error;
}

async function saveUpdatedFlag(id, flag) {
  const { data, error, count } = await supabase
    .from("CRM")
    .update({ isPreviewAgreementEnable: flag })
    .eq("id", id);
  if (data) return { data, count };
  else throw error;
}

async function moveToChangeAVTab(id) {
  const { data, error } = await supabase
    .from("CRM")
    .update({
      isApproved: false,
      crmStatusId: 1,
      isChangeableValue: false,
      parkingUpgradeCost: null,
      approvalRemark: null,
      last_updated_at: Date.now(),
    })
    .eq("id", id);
  if (data) return data;
  else throw error;
}

async function changeUpdateBucketingFlag(id) {
  const { data, error } = await supabase
    .from("AllotmentPayment")
    .update({ isBucketingApplied: false })
    .eq("allotmentPaymentId", id);
  if (data) return data;
  else throw error;
}

async function sendWhatsappMessageOnTagApprove(
  leadName,
  contactNumber,
  projectName,
  crmUserName,
  crmContact,
  crmEmail,
  unitNumber,
) {
  return await axios.post(
    `${process.env.REACT_APP_PAYMENT_LINK_URL}whatsapp/sendWaMsgOnTagApproved`,
    {
      // return await axios.post(`http://localhost:8053/whatsapp/sendWaMsgOnTagApproved`, {
      leadName,
      contactNumber,
      projectName,
      crmUserName,
      crmContact,
      crmEmail,
      unitNumber,
    },
  );
}

async function updateCrmByAllotmentPaymentId(id, payload) {
  return await supabase
    .from("CRM")
    .update(payload)
    .eq("allotmentPaymentId", id)
    .select("*");
}

async function updateEventLeadTokenAmount(paymentId, amount) {
  const { data, error } = await supabase
    .from("EventTokenLeadRelations")
    .update({ paidAmount: amount })
    .eq("paymentId", paymentId)
    .select("*")
    .maybeSingle();
  if (data) return { data };
  else throw error;
}
async function getEventLeadTokenAmount(paymentId, amount) {
  const { data, error } = await supabase
    .from("EventTokenLeadRelations")
    .select("*")
    .eq("paymentId", paymentId)
    .maybeSingle();
  if (data) return { data };
  else throw error;
}

async function getRefundedAmount(id) {
  const { data, error } = await supabase
    .from("AllotmentTransactions")
    .select("amount")
    .eq("allotmentPaymentId", id)
    .in("status", ["refund initiated", "refund processed"]);
  if (data) return { data };
  else throw error;
}

async function getCrmAllotment(id) {
  const { data, error } = await supabase
    .from("CRM")
    .select("*")
    .eq("allotmentPaymentId", id);

  if (data) return { data };
  else throw error;
}

async function getCompleteAllotmentTransactions(id) {
  const { data, error } = await supabase
    .from("AllotmentTransactions")
    .select("*")
    .eq("allotmentPaymentId", id)
    .eq("status", "complete")
    .order("created_at", { ascending: true });
  if (data) return { data };
  else throw error;
}

async function getPANConflicts(
  search,
  filterBy,
  checked,
  projectStr,
  selectedDate,
) {
  const { p, w, f } = projectStr;
  let all_cpId = [];
  let all_projectId = [];
  let all_salesRepresentativeId = [];
  let jsonParse;
  const SiteVisitFilters = {
    "Name Ascending": {
      key: "leadname",
      isAscending: true,
    },
    "Name Descending": {
      key: "leadname",
      isAscending: false,
    },
    "Oldest First": {
      key: "created_at",
      isAscending: true,
    },
    "Latest First": {
      key: "created_at",
      isAscending: false,
    },
  };
  let query = supabase
    .rpc("leadsfilter_with_panconflict")
    .order(SiteVisitFilters[filterBy].key, {
      ascending: SiteVisitFilters[filterBy].isAscending,
    });
  if (search && search !== "") {
    query = query.or(
      `leadname.ilike.%${search}%,panconflict_pannumber.ilike.%${search}%`,
    );
  }
  if (checked && checked.length > 0) {
    checked.map((item) => {
      jsonParse = JSON.parse(item);
      if (jsonParse.filter == "CP") {
        all_cpId.push(jsonParse.value);
      } else if (jsonParse.filter == "Projects") {
        all_projectId.push(jsonParse.value);
      } else if (jsonParse.filter == "Users") {
        all_salesRepresentativeId.push(jsonParse.value);
      }
    });
  }
  if (all_cpId.length !== 0) {
    query = query.in("cpid", all_cpId);
  }
  if (
    selectedDate?.[0]?.value !== "" &&
    selectedDate?.[1]?.value !== "" &&
    selectedDate !== undefined
  ) {
    query = query
      .lte("created_at", Date.parse(new Date(selectedDate?.[1]?.value)))
      .gte("created_at", Date.parse(new Date(selectedDate?.[0]?.value)));
  }
  if (all_salesRepresentativeId.length !== 0) {
    query = query.in("salesid", all_salesRepresentativeId);
  }
  if (all_projectId.length !== 0) {
    if (all_projectId[0]?.[0]?.["p"]?.length > 0) {
      query = query.in("projectpreferenceid", all_projectId[0]?.[0]?.["p"]);
    }
  }

  let { data, error } = await query;
  if (data) return { data };
  else throw error;
}

async function getDiscountAmountTotal(id) {
  const { data, error } = await supabase
    .from("AllotmentPriceDiscount")
    .select("allotmentPriceDiscountId, discountAmount")
    .eq("allotmentPaymentId", id)
    .in("typeOfDiscount", ["Preselect", "Referral", "GroupBuying"])
    .eq("isDiscountEligible", true);

  if (error) throw error;

  const totalDiscount =
    data?.reduce((acc, item) => acc + (item.discountAmount || 0), 0) || 0;
  const priceDiscountIds =
    data?.map((item) => item.allotmentPriceDiscountId) || [];

  return { totalDiscount, priceDiscountIds };
}

async function getLoyaltyDiscountAmountTotal(id) {
  const { data, error } = await supabase
    .from("AllotmentPriceDiscount")
    .select("*")
    .eq("allotmentPaymentId", id)
    .eq("typeOfDiscount", "Loyalty");

  const totalDiscount =
    data?.reduce((acc, item) => acc + (item.discountAmount || 0), 0) || 0;
  if (data) return totalDiscount;
  else throw error;
}

async function updateAllotmentPriceDiscount(ids) {
  const { data, error, count } = await supabase
    .from("AllotmentPriceDiscount")
    .update({ isDiscountApplied: true, last_updated_at: Date.now() })
    .in("allotmentPriceDiscountId", ids);
  if (data) return { data };
  else throw error;
}


async function getPANDataForLoyalty(allotment) {
  // const response = await axios.post('https://api.vjerp.com/api/getCustomerPanByCustomerId',
  // 	{ id: 23084 },
  // 	{
  // 		headers: {
  // 			'Authorization': '20a763e266308b35fc75feca4b053d5ce8ea540dbdaa77ee13b1a5e7ce8aadcf',
  // 			'Content-Type': 'application/json'
  // 		}
  // 	}
  // );

  // try {
  // 	const response = await axios.post(`http://localhost:8053/allotment/getRnLCustomerPan`, { custId: 12639 });
  // 	console.log("Response:", response);
  // 	return response.data;
  //   } catch (error) {
  // 	console.error("Error fetching customer data:", error);
  //   }

  let responsedata;
  try {
    responsedata = await axios.post(
      `${process.env.REACT_APP_PAYMENT_LINK_URL}allotment/getRnLCustomerPan`,
      { custId: allotment },
    );
  } catch (error) {
    responsedata = {
      data: {
        success: false,
        data: {
          id: "",
          name: "",
          PAN: "",
        },
      },
    };
  }

  return responsedata.data;
}

async function updateToCRMTableUnitCost(unitCost, allotmentPaymentId) {
  const { data, error } = await supabase
    .from("CRM")
    .update({ oldUnitCost: unitCost })
    .eq("allotmentPaymentId", allotmentPaymentId);
  if (data) return data;
  else throw error;
}

async function updateAllomentPaymentUnitCost(unitCost, allotmentPaymentId) {
  const { data, error } = await supabase
    .from("AllotmentPayment")
    .update({ unitCost: unitCost })
    .eq("allotmentPaymentId", allotmentPaymentId);
  if (data) return data;
  else throw error;
}

async function updateAllotmentPriceDiscountApplied(allotmentPaymentId) {
  const { data, error, count } = await supabase
    .from("AllotmentPriceDiscount")
    .update({ isDiscountApplied: true })
    .eq("allotmentPaymentId", allotmentPaymentId)
    .eq("typeOfDiscount", "Loyalty");
  if (data) return { data };
  else throw error;
}

async function getInventoryType(unitId) {
  const { data, error } = await supabase
    .from("Inventory")
    .select("inventoryTypeId")
    .eq("unitId", unitId);
  if (data) return data;
  else throw error;
}

async function updateAllotmentPriceDiscountReferral(allotmentPaymentId) {
  const { data, error, count } = await supabase
    .from("AllotmentPriceDiscount")
    .update({ isDiscountEligible: false })
    .eq("allotmentPaymentId", allotmentPaymentId)
    .eq("typeOfDiscount", "Loyalty");
  if (data) return { data };
  else throw error;
}

async function addReferralDiscountAllotmentPriceDiscount(details) {
  const { data, error } = await supabase.from("AllotmentPriceDiscount").insert({
    discountAmount: details.amount,
    typeOfDiscount: details.typeOfDiscount,
    allotmentPaymentId: details.allotmentPaymentId,
    isDiscountEligible: true,
    isDiscountApplied: true,
  });
  if (data) return data;
  else throw error;
}
async function getReferralDiscount(projectId, wingId, inventoryTypeId) {
  const { data, error } = await supabase
    .from("BookingAmounts")
    .select("referralDiscount")
    .eq("projectId", projectId)
    .eq("wingId", wingId)
    .eq("inventoryTypeId", inventoryTypeId);

  if (data) return data;
  else throw error;
}
async function getApplicantsData(id) {
  const { data, error } = await supabase
    .from("AgreementForm")
    .select("agreementFormId,Applicants!left(*)")
    .eq("allotmentPaymentId", id);
  if (data) return data;
  else throw error;
}

async function getFarvisionStatusForPNRD(unitId) {
  const { data, error } = await supabase
    .from("Inventory")
    .select("farvisionStatus")
    .eq("unitId", unitId);
  if (data) return data;
  else throw error;
}

// async function getAllotmentLetterData(allotmentPaymentId) {
//   const { data, error } = await supabase
//     .from("AllotmentPayment")
//     .select(`
//       allotmentPaymentId,
// 	  unitCost,
// 	  paidAmt,
//       unitId (
//         unitNo,
//         floorNo,
// 		saleableArea,
// 		chargeableArea,
//         inventoryTypeId(type),
//         projectId(projectName),
//         wingId(wingName)
//       ),
//       ParkingSelection (
//         parkingInventoryId (
//           parkingNumber,
//           floorNumber,
//           parkingArea,
//           parkingBreadth,
//           parkingHeight,
//           parkingLength
//         )
//       ),
// 	  InventoryChildArea(unitId(*))
//     `)
//     .eq("allotmentPaymentId", allotmentPaymentId)
//     .single();
// 	console.log('data', data)

//   if (error) throw error;

//   // Fetch AgreementForm separately
//   const { data: agreementForm, error: agreementError } = await supabase
//     .from("AgreementForm")
//     .select("applicants")
//     .eq("allotmentPaymentId", allotmentPaymentId)
//     .single();

//   if (agreementError && agreementError.code !== "PGRST116") throw agreementError;

//   const parking = data.ParkingSelection?.[0]?.parkingInventoryId || {};
//   const unit = data.unitId || {};
//   const project = unit.projectId || {};
//   const wing = unit.wingId || {};

//   // 👇 Always pick the first applicant
//   const applicantWrapper = agreementForm?.applicants?.[0] || {};
//   const applicant = applicantWrapper.applicant || {};

//   // Build full address
//   const addressParts = [
//     applicant.addressLine1,
//     applicant.addressLine2,
//     applicant.addressLine3,
//     applicant.city,
//     applicant.state,
//     applicant.pincode,
//     applicant.country,
//   ].filter(Boolean); // remove undefined/empty

//   const fullAddress = addressParts.join(", ");

//   return {
//     allotmentPaymentId: data.allotmentPaymentId,

//     // Applicant details
//     name:
//       applicant.nameAsperPAN ||
//       `${applicant.firstName || ""} ${applicant.middleName || ""} ${
//         applicant.lastName || ""
//       }`.trim(),
//     contactNumber: applicant.contactNumber || "NA",
//     email: applicant.email || "NA",
//     pan_number: applicant.panNumber || "NA",
//     aadhaar_number: applicant.aadharNumber || "NA",
//     address: fullAddress || "NA",

//     // Parking details
//     parkingNumber: parking.parkingNumber,
//     parkingfloor: parking.floorNumber,
//     parkingArea: parking.parkingArea,
//     parkingBreadth: parking.parkingBreadth,
//     parkingHeight: parking.parkingHeight,
//     parkingLength: parking.parkingLength,

//     // Unit details
//     unitNo: unit.unitNo,
//     floorNo: unit.floorNo,
// 	saleableArea: unit.saleableArea,
//     UnitType: unit.inventoryTypeId?.type,
//     projectName: project.projectName,
//     wingName: wing.wingName,
// 	unitCost: data.unitCost,
// 	paidAmt: data.paidAmt,

//     // Raw applicants
//     applicants: agreementForm?.applicants || [],
//   };
// }

async function getAllotmentLetterData(allotmentPaymentId) {
  // Fetch AllotmentPayment data along with related tables
  const { data, error } = await supabase
    .from("AllotmentPayment")
    .select(
      `
      allotmentPaymentId,
	  leadId,
      unitCost,
      paidAmt,
	  bookingFormId,
      unitId (
        unitNo,
        unitId,
        floorNo,
        saleableArea,
        chargeableArea,
        unitOf,
		farvisionStatus,
        inventoryTypeId(type),
        projectId(projectId, projectName),
        wingId(wingName)
      ),
      ParkingSelection (
        parkingInventoryId (
          parkingNumber,
          floorNumber,
          parkingArea,
          parkingBreadth,
          parkingHeight,
          parkingLength
        )
      )
    `,
    )
    .eq("allotmentPaymentId", allotmentPaymentId)
    .single();

  if (error) throw error;

  // Fetch InventoryChildArea based on the unitId
  const unitId = data.unitId?.unitId; // Get the unitId from the AllotmentPayment data
  console.log("data", data);

  const bookingFormId = data.bookingFormId;

  const leadId = data.leadId;

  const { data: inventoryChildAreaData, error: inventoryChildAreaError } =
    await supabase
      .from("InventoryChildArea")
      .select("*") // Select all columns from InventoryChildArea
      .eq("unitId", unitId); // Join using unitId

  //   if (inventoryChildAreaError) throw inventoryChildAreaError;

  console.log("InventoryChildArea Data:", inventoryChildAreaData);

  // Fetch AgreementForm separately
  //   const { data: agreementForm, error: agreementError } = await supabase
  //     .from("AgreementForm")
  //     .select("applicants")
  //     .eq("allotmentPaymentId", allotmentPaymentId)
  //     .single();

  //   if (agreementError && agreementError.code !== "PGRST116") throw agreementError;

  const { data: Leads, error: LeadError } = await supabase
    .from("Leads")
    .select("leadId,personId(contactNumber)")
    .eq("leadId", leadId)
    .single();

  // Fetch BookingForm separately
  const { data: BookingForm, error: BookingError } = await supabase
    .from("BookingForm")
    .select("*")
    .eq("bookingFormId", bookingFormId)
    .single();
  //   if (BookingError && BookingError.code !== "PGRST116") throw BookingError;

  const parking = data.ParkingSelection?.[0]?.parkingInventoryId || {};
  const unit = data.unitId || {};
  const project = unit.projectId || {};
  const wing = unit.wingId || {};

  // 👇 Always pick the first applicant
  //   const applicantWrapper = agreementForm?.applicants?.[0] || {};
  //   const applicant = applicantWrapper.applicant || {};

  // Build full address
  //   const addressParts = [
  //     applicant.addressLine1,
  //     applicant.addressLine2,
  //     applicant.addressLine3,
  //     applicant.city,
  //     applicant.state,
  //     applicant.pincode,
  //     applicant.country,
  //   ].filter(Boolean); // remove undefined/empty

  const addressParts = [
    BookingForm?.addressLine1 || "",
    BookingForm?.addressLine2 || "",
    BookingForm?.addressLine3 || "",
    BookingForm?.city || "",
    BookingForm?.state || "",
    BookingForm?.pincode || "",
    BookingForm?.country || "",
  ].filter(Boolean);

  const fullAddress = addressParts.join(", ");

  console.log("inventoryChildAreaData============", inventoryChildAreaData);
  // Calculate chargeableArea - InventoryChildArea.area
  const chargeableArea = unit.chargeableArea || 0;
  const inventoryChildArea =
    inventoryChildAreaData.reduce((sum, row) => sum + (row.area || 0), 0) || 0;
  // VJ units: RERA carpet area = chargeable area minus the child areas.
  // Landowner units: no child-area subtraction — use the chargeable area as-is.
  const isLandownerUnit = unit.unitOf === "Landowner";
  const areaDifference = isLandownerUnit
    ? chargeableArea
    : chargeableArea - inventoryChildArea;

  // Convert carpet area from sq.mt to sq.ft (1 sq.mt = 10.764 sq.ft)
  const areaDifferenceInSqFt = areaDifference * 10.764;

  console.log("Leads", Leads);
  return {
    allotmentPaymentId: data.allotmentPaymentId,

    // Applicant details
    // name:
    //   applicant.nameAsperPAN ||
    //   `${applicant.firstName || ""} ${applicant.middleName || ""} ${
    //     applicant.lastName || ""
    //   }`.trim(),
    // contactNumber: applicant.contactNumber || "NA",
    // email: applicant.email || "NA",
    // pan_number: applicant.panNumber || "NA",
    // aadhaar_number: applicant.aadharNumber || "NA",
    // address: fullAddress || "NA",

    name: ` ${BookingForm?.salutation || ""} ${BookingForm?.firstName || ""} ${BookingForm?.middleName || ""} ${
      BookingForm?.lastName || ""
    }`.trim(),
    contactNumber:
      BookingForm?.contactNumber || Leads?.personId?.contactNumber || "",
    email: BookingForm?.email || "",
    pan_number: BookingForm?.panNumber || "",
    aadhaar_number: BookingForm?.aadharNumber || "",
    address: fullAddress || "",

    // Parking details
    parkingNumber: parking.parkingNumber,
    parkingfloor: parking.floorNumber,
    parkingArea: parking.parkingArea,
    parkingBreadth: parking.parkingBreadth,
    parkingHeight: parking.parkingHeight,
    parkingLength: parking.parkingLength,

    // Unit details
    unitNo: unit.unitNo,
    floorNo: unit.floorNo,
    saleableArea: unit.saleableArea,
    chargeableArea: unit.chargeableArea,
    farvisionStatus: unit.farvisionStatus,
    UnitType: unit.inventoryTypeId?.type,
    projectName: project.projectName,
    wingName: wing.wingName,
    unitCost: data.unitCost,
    paidAmt: data.paidAmt,
    projectId: project.projectId,

    // InventoryChildArea details
    inventoryChildArea: inventoryChildAreaData[0]?.area || [],

    // Chargeable area - InventoryChildArea area
    areaDifference: areaDifference, // Display the result

    // Chargeable area - InventoryChildArea area (in square feet)
    areaDifferenceInSqFt: areaDifferenceInSqFt.toFixed(2), // Display the result in square feet

    // Raw applicants
    // applicants: agreementForm?.applicants || [],
  };
}

export {
  getAllotments,
  getTokensByLeadId,
  getAllAllotmentTransactions,
  getAllMachines,
  getAllotmentPayment,
  getAllotmentTransactions,
  getAllotmentById,
  getFilterNames,
  insertAllotmentTransactions,
  getFilterById,
  uploadChequeImage,
  uploadAgreementReceipt,
  getAgreementStatusByAllotmentIds,
  updateAllotmentPayment,
  getAllotmentsFilter,
  insertInventoryLogs,
  getCrmAllotments,
  getTagApprovedCrmAllotments,
  getChangedPlanCrmAllotments,
  getCompletedCrmAllotments,
  getTagPendingCrmAllotments,
  approveCrmAllotment,
  approveTagCrmAllotment,
  approveTagCrmAllotmentCreateApplication,
  rejectTagCrmAllotment,
  sendWelcomePdf,
  updateCrmAllotment,
  insertTransactionLogs,
  insertIntoAllotmentTransactions,
  getApiSuccessLogs,
  getAgreementDoneCrmAllotments,
  getParkingSelectionCrmAllotments,
  updateParkingSelectionFlag,
  getUpdateSDRCrmAllotments,
  changeUpdateSDRStatus,
  approveUpdateSDRStatus,
  getSentEmailCount,
  ChangeBookingAmountValues,
  insertUpdatedBookingAmountLogs,
  getSdrPercentageAndLegalCharges,
  getJdBuIdForUnit,
  getJdProjectIdForUnit,
  getJdCompanyDetailsForUnit,
  getURLFromAgreementForm,
  sendForOcrApproval,
  moveToAgreementAfterOcrApproval,
  getCancellationsCrmAllotments,
  insertParkingDetails,
  fetchParkingData,
  getErrorResponseForApiType,
  // getStampDetailsBookingUrl
  getVirtualAccDetailsById,
  fetchSelectedParkingNumbers,
  getParkingNumbersFromParkingInventory,
  approveChangeApplicantRequestCRM,
  approveChangeApplicantRequest,
  getParkingTypes,
  insertCRMLogs,
  getParkingUpgradeCost,
  deleteOldParkingRecords,
  // getStampDetailsBookingUrl
  getAggrementId,
  getApplicantId,
  getCRMTimelineData,
  getLeadIdForCRMUser,
  updateParkingStatusFlag,
  getLegalCharges,
  getChangeApplicantById,
  getFilterNamesCollaterals,
  updateSkipDraftDetailsInCRM,
  getPreviewAgreementToCustomer,
  saveUpdatedFlag,
  sendWhatsappMessageOnTagApprove,
  updateCrmByAllotmentPaymentId,
  updateEventLeadTokenAmount,
  getEventLeadTokenAmount,
  updateUnitCostInAllotmentPayment,
  getRefundedAmount,
  getCrmAllotment,
  getCompleteAllotmentTransactions,
  getPANConflicts,
  getDiscountAmountTotal,
  getLoyaltyDiscountAmountTotal,
  updateAllotmentPriceDiscount,
  getPANDataForLoyalty,
  getApplicantsData,
  updateToCRMTableUnitCost,
  updateAllomentPaymentUnitCost,
  updateAllotmentPriceDiscountApplied,
  getInventoryType,
  getReferralDiscount,
  updateAllotmentPriceDiscountReferral,
  addReferralDiscountAllotmentPriceDiscount,
  getAllotmentLetterData,
  getFarvisionStatusForPNRD,
};
